(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-architect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-precision-booking]');
    if (!root) return;
    var frame = root.querySelector('iframe[data-src]') || root.querySelector('iframe');
    if (!frame) return;

    root.setAttribute('data-js', '');

    // ---- guard: undo form_embed.js hiding our iframe ----------------------
    // Measured on the live page: form_embed.js intermittently applies
    // "opacity:0; visibility:hidden; pointer-events:none; left:-9999px; position:absolute"
    // to our frame and collapses it to 150px. It is a race — it does not happen on
    // every load, which is why the page looked fine in a fresh window and broken on a
    // refresh. Strip the treatment whenever it appears.
    function unhide() {
      var s = frame.style;
      var hidden =
        s.visibility === 'hidden' ||
        s.opacity === '0' ||
        s.pointerEvents === 'none' ||
        parseInt(s.left, 10) < -1000;
      if (!hidden) return;
      s.removeProperty('opacity');
      s.removeProperty('visibility');
      s.removeProperty('pointer-events');
      s.removeProperty('left');
      s.removeProperty('position');
    }

    new MutationObserver(function () {
      unhide();
      // Backstop (2026-10-26): whatever height their script writes on the iframe, the
      // wrapper takes too — the two can never disagree, whatever the message says.
      var h = parseInt(frame.style.height, 10);
      if (h > 150 && root.style.getPropertyValue('--precision-booking-content-height') !== h + 'px') applyHeight(h);
    }).observe(frame, {
      attributes: true,
      attributeFilter: ['style']
    });

    function reveal() {
      root.setAttribute('data-loaded', '');
      unhide();
    }

    frame.addEventListener('load', reveal);

    // ---- height: taken from GHL's own message, applied to both ------------
    // GHL posts "[iFrameSizer]<iframeId>:<height>:<width>:<type>" on every content
    // resize (iframe-resizer's order: HEIGHT then WIDTH — see THE THIRD BUG above).
    // We put it on the wrapper (which reserves the page space) AND on the iframe, so
    // the layout is correct whether or not their script is behaving.
    function applyHeight(height) {
      if (!height || height <= 0) return;
      root.style.setProperty('--precision-booking-content-height', height + 'px');
      root.setAttribute('data-sized', '');
      if (parseInt(frame.style.height, 10) !== height) frame.style.height = height + 'px';
    }
    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://api.leadconnectorhq.com') return;

      var data = event.data;
      if (typeof data !== 'string' || data.slice(0, 13) !== '[iFrameSizer]') return;

      var parts = data.slice(13).split(':');
      if (parts[0] !== frame.id) return;

      var height = parseInt(parts[1], 10);      // parts[2] is the width
      if (!height || height <= 0) return;
      applyHeight(height);
      reveal();
    });

    var loaded = false;
    function load() {
      if (loaded) return;
      loaded = true;
      if (frame.dataset.src) {
        frame.src = frame.dataset.src;
        frame.removeAttribute('data-src');
      }
      if (!document.querySelector('script[data-ghl-form-embed]')) {
        var s = document.createElement('script');
        s.src = 'https://link.msgsndr.com/js/form_embed.js';
        s.async = true;
        s.setAttribute('data-ghl-form-embed', '');
        document.body.appendChild(s);
      }
    }

    // The calendar is the page's purpose — never leave it unloaded for long.
    setTimeout(load, 2500);

    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { load(); io.disconnect(); } });
    }, { rootMargin: '800px 0px' });
    io.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["precision-room-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var root = document.querySelector('[data-precision-fit]');
    if (!root) return;

    var dataEl = document.querySelector('[data-precision-fit-data]');
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    // the catalogue join — fit component id → live product (snippets/precision-fit-catalogue.liquid)
    var CAT = {};
    try { var catEl = document.querySelector('[data-precision-fit-catalogue]'); if (catEl) CAT = JSON.parse(catEl.textContent) || {}; } catch (e) { CAT = {}; }
    var buySel = {};   // per build key: the option values the buyer has chosen in "Buy this build"

    var form = root.querySelector('[data-fit-form]');
    var golfersEl = root.querySelector('[data-golfers]');
    var obstructionsEl = root.querySelector('[data-obstructions]');
    var errorEl = root.querySelector('[data-fit-error]');
    var resultsEl = root.querySelector('[data-fit-results]');
    var buildsEl = root.querySelector('[data-builds]');
    var swingEl = root.querySelector('[data-swing-test]');
    var svgWrap = root.querySelector('[data-svg]');
    var legendEl = root.querySelector('[data-drawing-legend]');
    var drawingBuildEl = root.querySelector('[data-drawing-build]');
    var provEl = root.querySelector('[data-provenance-list]');
    var consultLink = root.querySelector('[data-consult-link]');
    var copyBtn = root.querySelector('[data-copy-link]');
    var copiedEl = root.querySelector('[data-copied]');
    var consultBase = root.getAttribute('data-consult-url') || '/pages/consultation';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- helpers ----------
    function el(tag, attrs, children) {
      var n = document.createElement(tag);
      if (attrs) Object.keys(attrs).forEach(function (k) {
        if (k === 'text') n.textContent = attrs[k];
        else if (k === 'class') n.className = attrs[k];
        else n.setAttribute(k, attrs[k]);
      });
      if (children) children.forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
      return n;
    }
    function ftin(inches, opts) {
      opts = opts || {};
      if (inches == null || isNaN(inches)) return '—';
      var neg = inches < 0; var a = Math.abs(inches);
      var ft = Math.floor(a / 12); var rem = a - ft * 12;
      var inr = Math.round(rem * 4) / 4;
      if (inr >= 12) { ft += 1; inr = 0; }
      var s = '';
      if (ft) s += ft + '′';
      if (inr || !ft) s += (ft ? ' ' : '') + (inr % 1 === 0 ? inr : inr.toFixed(2).replace(/0+$/, '')) + '″';
      return (neg ? '−' : '') + s;
    }
    function inchesOnly(v) { return (Math.round(v * 10) / 10) + '″'; }
    function thumb(src, alt, cls) { if (!src) return null; return el('img', { src: src, alt: alt || '', loading: 'lazy', width: '84', height: '84', class: cls || '' }); }
    function strip(items) {
      var ul = el('ul', { class: 'precision-fit__strip' }), any = false;
      items.forEach(function (it) { if (!it[0]) return; any = true; ul.appendChild(el('li', {}, [thumb(it[0], it[1]), el('span', { text: it[1] })])); });
      return any ? ul : null;
    }
    var wideScreen = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    function fold(eyebrowText, hint, body, openDesktop) {
      var d = el('details', { class: 'precision-fit__fold' });
      if (openDesktop && wideScreen) d.setAttribute('open', '');
      var sm = el('summary', { class: 'precision-fit__fold-summary' }, [el('span', { class: 'precision-fit__eyebrow', text: eyebrowText })]);
      if (hint) sm.appendChild(el('span', { class: 'precision-fit__fold-hint', text: hint }));
      d.appendChild(sm); d.appendChild(body); return d;
    }
    function toIn(ft, inch) { return (parseFloat(ft) || 0) * 12 + (parseFloat(inch) || 0); }
    function fmtMargin(m) {
      if (m == null) return '—';
      if (m >= 0) return '+' + ftin(m) + ' to spare';
      return ftin(m) + ' short';
    }
    function marginClass(m, atMinOnly) {
      if (m == null) return '';
      if (m < 0) return 'precision-fit__margin--neg';
      return atMinOnly ? 'precision-fit__margin--min' : 'precision-fit__margin--ok';
    }

    // ---------- dynamic rows ----------
    var golferCount = 0, obsCount = 0;
    function addGolfer(h, hand) {
      golferCount++;
      var id = 'g' + golferCount;
      var row = el('div', { class: 'precision-fit__row precision-fit__row--golfer', 'data-golfer-row': '' });
      var hFt = el('input', { type: 'number', name: id + '_ft', min: '3', max: '8', step: '1', inputmode: 'numeric', 'aria-label': 'Golfer height, feet', required: '' });
      var hIn = el('input', { type: 'number', name: id + '_in', min: '0', max: '11.99', step: '0.5', inputmode: 'decimal', 'aria-label': 'Golfer height, inches', value: '0' });
      if (h != null) { hFt.value = Math.floor(h / 12); hIn.value = Math.round((h - Math.floor(h / 12) * 12) * 2) / 2; }
      var sel = el('select', { name: id + '_hand', 'aria-label': 'Plays right- or left-handed' });
      sel.appendChild(el('option', { value: 'right', text: 'Right-handed' }));
      sel.appendChild(el('option', { value: 'left', text: 'Left-handed' }));
      if (hand === 'left') sel.value = 'left';
      var remove = el('button', { type: 'button', class: 'precision-fit__remove', text: 'Remove', 'aria-label': 'Remove this golfer' });
      remove.addEventListener('click', function () { if (golfersEl.children.length > 1) row.remove(); });
      row.appendChild(el('div', {}, [
        el('span', { class: 'precision-fit__label', text: 'Height' }),
        el('div', { class: 'precision-fit__ftin' }, [
          el('label', {}, [hFt, el('span', { text: 'ft', 'aria-hidden': 'true' })]),
          el('label', {}, [hIn, el('span', { text: 'in', 'aria-hidden': 'true' })])
        ])
      ]));
      row.appendChild(el('div', {}, [el('span', { class: 'precision-fit__label', text: 'Plays' }), sel]));
      row.appendChild(remove);
      golfersEl.appendChild(row);
    }
    function addObstruction(type, dist, clear) {
      obsCount++;
      var id = 'o' + obsCount;
      var row = el('div', { class: 'precision-fit__row precision-fit__row--obstruction', 'data-obstruction-row': '' });
      var sel = el('select', { name: id + '_type', 'aria-label': 'Type of obstruction' });
      [['duct', 'Duct'], ['beam', 'Beam or joist'], ['soffit', 'Soffit or bulkhead'], ['light', 'Light fixture'], ['other', 'Something else']].forEach(function (o) {
        sel.appendChild(el('option', { value: o[0], text: o[1] }));
      });
      if (type) sel.value = type;
      var dFt = el('input', { type: 'number', name: id + '_dft', min: '0', max: '80', step: '1', inputmode: 'numeric', 'aria-label': 'Distance from the screen wall, feet' });
      var dIn = el('input', { type: 'number', name: id + '_din', min: '0', max: '11.99', step: '0.25', inputmode: 'decimal', 'aria-label': 'Distance from the screen wall, inches', value: '0' });
      var cFt = el('input', { type: 'number', name: id + '_cft', min: '0', max: '30', step: '1', inputmode: 'numeric', 'aria-label': 'Height to its underside, feet' });
      var cIn = el('input', { type: 'number', name: id + '_cin', min: '0', max: '11.99', step: '0.25', inputmode: 'decimal', 'aria-label': 'Height to its underside, inches', value: '0' });
      if (dist != null) { dFt.value = Math.floor(dist / 12); dIn.value = Math.round((dist % 12) * 4) / 4; }
      if (clear != null) { cFt.value = Math.floor(clear / 12); cIn.value = Math.round((clear % 12) * 4) / 4; }
      var remove = el('button', { type: 'button', class: 'precision-fit__remove', text: 'Remove', 'aria-label': 'Remove this obstruction' });
      remove.addEventListener('click', function () { row.remove(); });
      row.appendChild(el('div', {}, [el('span', { class: 'precision-fit__label', text: 'What is it' }), sel]));
      row.appendChild(el('div', {}, [
        el('span', { class: 'precision-fit__label', text: 'Distance from the screen wall' }),
        el('div', { class: 'precision-fit__ftin' }, [
          el('label', {}, [dFt, el('span', { text: 'ft', 'aria-hidden': 'true' })]),
          el('label', {}, [dIn, el('span', { text: 'in', 'aria-hidden': 'true' })])
        ])
      ]));
      row.appendChild(el('div', {}, [
        el('span', { class: 'precision-fit__label', text: 'Height to its underside' }),
        el('div', { class: 'precision-fit__ftin' }, [
          el('label', {}, [cFt, el('span', { text: 'ft', 'aria-hidden': 'true' })]),
          el('label', {}, [cIn, el('span', { text: 'in', 'aria-hidden': 'true' })])
        ])
      ]));
      row.appendChild(remove);
      obstructionsEl.appendChild(row);
    }
    root.querySelector('[data-add-golfer]').addEventListener('click', function () { addGolfer(); });
    root.querySelector('[data-add-obstruction]').addEventListener('click', function () { addObstruction(); });

    // ---------- read form ----------
    function readState() {
      var f = form.elements;
      var s = {
        w: toIn(f.w_ft.value, f.w_in.value),
        l: toIn(f.l_ft.value, f.l_in.value),
        c: toIn(f.c_ft.value, f.c_in.value),
        golfers: [], obs: [], swingTest: state ? state.swingTest : null, selected: state ? state.selected : null,
        assembled: state ? state.assembled : null, view: state ? state.view : 'elevation'
      };
      Array.prototype.forEach.call(golfersEl.querySelectorAll('[data-golfer-row]'), function (row) {
        var ins = row.querySelectorAll('input'); var sel = row.querySelector('select');
        var h = toIn(ins[0].value, ins[1].value);
        if (h > 0) s.golfers.push({ h: h, hand: sel.value });
      });
      Array.prototype.forEach.call(obstructionsEl.querySelectorAll('[data-obstruction-row]'), function (row) {
        var ins = row.querySelectorAll('input'); var sel = row.querySelector('select');
        var d = toIn(ins[0].value, ins[1].value), c = toIn(ins[2].value, ins[3].value);
        if (c > 0) s.obs.push({ type: sel.value, d: d, clear: c });
      });
      return s;
    }
    function validate(s) {
      if (!(s.w > 0 && s.l > 0 && s.c > 0)) return 'Enter the room’s width, length and ceiling height.';
      if (!s.golfers.length) return 'Add at least one golfer with a height.';
      if (s.w < 36 || s.l < 36 || s.c < 36) return 'One of those measurements is under three feet — check the feet and inches fields.';
      return null;
    }

    // ---------- the engine ----------
    var R = D.room;
    var MAT = D.mats[0];
    var PROJ = D.projectors[0];                // the curated projector (both builds)
    var ALL_LM = D.launchMonitors.concat(D.launchMonitorsMore || []);   // every unit offered in Assemble your own
    function projById(id) { return D.projectors.filter(function (p) { return p.id === id; })[0] || PROJ; }
    function fwdText(lm) {
      var f = lm.forwardOfTeeIn || 0;
      if (f > 0) return ftin(f) + ' in front of the tee';
      if (f < 0) return ftin(-f) + ' behind the tee';
      return 'over the tee';
    }
    var TEE = R.teeToScreen.recMinIn;          // 120 — Carl's minimum and the near end of the recommended band
    var LM_BAND = 12;                          // depth band an overhead unit occupies, for obstruction checks

    function ceilingIn(s, zone) {
      var c = s.c;
      s.obs.forEach(function (o) {
        var a = o.d - 6, b = o.d + 6;
        if (b >= zone[0] && a <= zone[1]) c = Math.min(c, o.clear);
      });
      return c;
    }

    function evaluateBuild(s, lm, enc, opts) {
      opts = opts || {};
      var both = opts.forceSingle ? false : hasBoth(s.golfers);
      var overhead = lm.mountClass === 'overhead';
      var radar = lm.mountClass === 'rear';
      var P = opts.proj || PROJ;
      var rearRec = R.rearOfScreen.recIn, rearMin = R.rearOfScreen.minIn;
      var m = {};

      // zones along the depth axis, measured from the screen wall
      var zEnc = [rearRec, rearRec + enc.floorDepthIn];
      var zSwing = [Math.max(0, TEE - R.swingRadiusIn), TEE + R.swingRadiusIn];
      var zLm = [TEE - (lm.forwardOfTeeIn || 0) - LM_BAND / 2, TEE - (lm.forwardOfTeeIn || 0) + LM_BAND / 2];

      // ceiling — enclosure (hard)
      var cEnc = ceilingIn(s, zEnc);
      m.ceilEnc = { avail: cEnc, req: enc.outerHIn, margin: cEnc - enc.outerHIn, hard: true, label: 'Ceiling for the enclosure frame', src: enc.src };

      // ceiling — overhead device (hard at min, rec at Carl's ideal)
      var cLm = null;
      if (overhead) {
        cLm = ceilingIn(s, zLm);
        var devMin = lm.deviceCeilingIn.minIn + MAT.thicknessIn;
        m.ceilDev = { avail: cLm, req: devMin, reqRec: lm.deviceCeilingIn.recIn, tol: lm.deviceCeilingIn.toleranceIn,
          margin: cLm - devMin, marginRec: cLm - lm.deviceCeilingIn.recIn, hard: true, label: 'Ceiling for the overhead launch monitor', src: lm.srcs[0] };
      }

      // ceiling — swing band (published bands; the golfer-specific number is UNKNOWN)
      var cSwing = ceilingIn(s, zSwing);
      var band = cSwing >= R.ceiling.recIn ? 'rec' : cSwing >= R.ceiling.minIn ? 'conditional' : 'below';
      if (band === 'conditional' && s.swingTest === true) band = 'tested';
      if (band === 'conditional' && s.swingTest === false) band = 'failed';
      m.ceilSwing = { avail: cSwing, req: R.ceiling.minIn, reqRec: R.ceiling.recIn, band: band, hard: true, label: 'Ceiling for the swing', src: R.ceiling.src };

      // width
      var laneRec = R.widthCentredRecIn, laneMin = both ? R.widthCentredRecIn : R.widthOffsetMinIn;
      m.width = { avail: s.w, req: Math.max(enc.outerWIn, laneMin), reqRec: Math.max(enc.outerWIn, laneRec),
        margin: s.w - Math.max(enc.outerWIn, laneMin), marginRec: s.w - Math.max(enc.outerWIn, laneRec), hard: true,
        label: 'Width', src: R.widthSrc, both: both, offset: (!both && s.w < laneRec) };

      // lane inside the enclosure — DERIVED (step 4). When the frame reaches the tee (Pro 10 ft and 15 ft depths)
      // the golfer swings between the sidewalls, so Carl's room-width figures are applied to the frame's outer width.
      var enclosed = (rearRec + enc.floorDepthIn) >= TEE;
      if (enclosed) {
        m.lane = { avail: enc.outerWIn, req: laneMin, reqRec: laneRec, margin: enc.outerWIn - laneMin, marginRec: enc.outerWIn - laneRec,
          hard: true, label: 'Width inside the enclosure', src: R.widthSrc, derived: true, both: both };
        m.width.offset = (!both && enc.outerWIn < laneRec);
      }

      // depth
      var behindMin = radar ? Math.max(R.behindTee.minIn, lm.behindTeeMinIn || 0) : R.behindTee.minIn;
      var behindRec = radar ? Math.max(R.behindTee.recIn, lm.behindTeeRecIn || lm.behindTeeMinIn || 0) : R.behindTee.recIn;
      var dRec = rearRec + TEE + behindRec;
      var dMin = rearMin + R.teeToScreen.minIn + behindMin;
      // the frame itself must sit inside the room behind the rear buffer (step 4 — the deep Pro sizes)
      var encEnd = rearMin + enc.floorDepthIn, encEndRec = rearRec + enc.floorDepthIn, encGoverns = encEnd > dMin;
      if (encGoverns) dMin = encEnd;
      if (encEndRec > dRec) dRec = encEndRec;
      m.depth = { avail: s.l, req: dMin, reqRec: dRec, margin: s.l - dMin, marginRec: s.l - dRec, hard: true, label: 'Length', src: encGoverns ? enc.src : (radar ? lm.srcs[0] : R.teeToScreen.src), radar: radar, behindMin: behindMin, encGoverns: encGoverns };

      // projector — throw for an image whose height matches the screen (D36)
      var frameW = enc.viewableHIn * P.aspect;
      var tMin = P.throwRatio.min * frameW, tMax = P.throwRatio.max * frameW;
      var tFit = Math.min(tMax, s.l - P.bodyIn.d);   // must be inside the room
      var projInRoom = tFit >= tMin;
      var behind = tFit - TEE;
      var zProj = [tFit - P.bodyIn.d / 2, tFit + P.bodyIn.d / 2];
      var cProj = ceilingIn(s, zProj);
      // lens height above the image bottom (assumed near floor level — a stated tolerance):
      //   offset 0 with lens shift  → the lens may rise to (0.5 + shift) × image height   (LK936ST: 1.10 H)
      //   offset ≥ 100%, no shift   → the lens sits at offset × image height, fixed       (LK830ST: 1.14 H)
      //   offset not published      → unknown; reported as such
      var lensRule = P.offsetPct == null ? 'unknown' : (P.offsetPct >= 1 ? 'fixed' : 'shift');
      var maxLens = lensRule === 'shift' ? (P.offsetPct + 0.5 + P.vShiftPct) * enc.viewableHIn : lensRule === 'fixed' ? P.offsetPct * enc.viewableHIn : null;
      var reqDrop = maxLens == null ? null : Math.max(0, cProj - maxLens);
      var projTooHigh = lensRule === 'fixed' && (maxLens + P.bodyIn.h / 2) > cProj;
      var swingClear = 24;   // BenQ's guidance — 2–3 ft behind the hitting area — applied to every projector as the swing-clearance test
      m.proj = { id: P.id, name: P.name, tMin: tMin, tMax: tMax, t: tFit, inRoom: projInRoom, behindTee: behind, lensRule: lensRule,
        clearOfSwing: behind >= swingClear, maxLens: maxLens, ceiling: cProj, reqDrop: reqDrop, tooHigh: projTooHigh, hard: true, src: P.srcs[1] || P.srcs[0] };

      // classify
      var fails = [];
      if (m.ceilEnc.margin < 0) fails.push('ceilEnc');
      if (overhead && m.ceilDev.margin < 0) fails.push('ceilDev');
      if (band === 'below' || band === 'failed') fails.push('ceilSwing');
      if (m.width.margin < 0) fails.push('width');
      if (m.lane && m.lane.margin < 0) fails.push('lane');
      if (m.depth.margin < 0) fails.push('depth');
      if (!projInRoom) fails.push('proj');
      if (projTooHigh) fails.push('projHeight');

      var atRec = m.width.marginRec >= 0 && (!m.lane || m.lane.marginRec >= 0) && m.depth.marginRec >= 0 && (!overhead || m.ceilDev.marginRec >= 0) && (band === 'rec');
      var verdict = fails.length ? 'no' : (atRec ? 'fits' : 'reduced');
      var conditional = !fails.length && band === 'conditional';

      return { lm: lm, enc: enc, proj: P, m: m, fails: fails, verdict: verdict, conditional: conditional, both: both, tested: band === 'tested' };
    }

    function hasBoth(golfers) {
      var r = false, l = false;
      golfers.forEach(function (g) { if (g.hand === 'left') l = true; else r = true; });
      return r && l;
    }

    function encFamily(e) { return e.family || 'diy'; }
    function withDepth(enc, key) {
      // Pro enclosures carry a depth map (Carl's Pro spec PDF); the chosen depth becomes the frame depth. DIY has one depth.
      if (!enc.depths || !key || !enc.depths[key]) return enc;
      var d = enc.depths[key], out = {};
      Object.keys(enc).forEach(function (k) { out[k] = enc[k]; });
      out.id = enc.id + '@' + key; out.baseId = enc.id; out.depthKey = String(key); out.depthFt = +key;
      out.frameDepthIn = d.frameDepthIn; out.floorDepthIn = d.floorDepthIn;
      return out;
    }
    function encName(enc) { return (encFamily(enc) === 'pro' ? 'Carl’s Place Pro ' : 'Carl’s Place ') + enc.label; }
    function encDepthText(enc) { return (enc.depthFt ? enc.depthFt + ' ft' : (encFamily(enc) === 'diy' ? '5 ft' : ftin(enc.frameDepthIn))) + ' deep'; }   // DIY: Carl's own '5 ft' token (59.125 in frame)
    function encImage(enc) { return encFamily(enc) === 'pro' ? D.enclosureImagePro : D.enclosureImage; }
    function enclosuresLargestFirst(family) {
      family = family || 'diy';
      return D.enclosures.filter(function (e) { return encFamily(e) === family; }).sort(function (a, b) { return (b.viewableHIn * b.viewableWIn) - (a.viewableHIn * a.viewableWIn); });
    }
    function enclosureChoices() {
      // Assemble your own: every DIY size, then every Pro size at every depth Carl's offers for it
      var out = enclosuresLargestFirst('diy');
      enclosuresLargestFirst('pro').forEach(function (e) {
        (e.depthsOffered || Object.keys(e.depths || {})).forEach(function (k) { out.push(withDepth(e, k)); });
      });
      return out;
    }

    function bestFor(s, lm, opts) {
      var list = enclosuresLargestFirst();
      var firstReduced = null, smallestFail = null, all = [];
      for (var i = 0; i < list.length; i++) {
        var r = evaluateBuild(s, lm, list[i], opts);
        all.push(r);
        if (r.verdict === 'fits') return { best: r, all: all };
        if (r.verdict === 'reduced' && !firstReduced) firstReduced = r;
        smallestFail = r;
      }
      return { best: firstReduced, all: all, smallestFail: firstReduced ? null : smallestFail };
    }

    function evaluate(s) {
      var out = { builds: [], verdict: 'no', conditional: false };
      D.launchMonitors.forEach(function (lm) {
        var res = bestFor(s, lm);
        var b = { lm: lm, result: res.best, all: res.all, unlocks: [] };
        if (!res.best) {
          // generate unlocks: single change at a time
          var fail = res.smallestFail;
          b.failing = fail;
          if (hasBoth(s.golfers)) {
            var single = bestFor(s, lm, { forceSingle: true });
            if (single.best) b.unlocks.push({ id: 'single', text: 'Plan the hitting position for one handedness. Carl’s publishes 10 ft as the minimum width with an offset hitting area, against 14 ft for centered hitting that serves both right- and left-handed golfers. You give up centered play for the second golfer.', result: single.best });
          }
        }
        out.builds.push(b);
      });
      // cross-build unlock: the other mount class
      out.builds.forEach(function (b, i) {
        if (b.result) return;
        var other = out.builds[1 - i];
        if (other.result) {
          var lm = b.lm, olm = other.lm;
          var txt = olm.mountClass === 'side'
            ? 'A side-placed launch monitor removes the ceiling requirement for the device — the ceiling then only has to clear the swing and the enclosure. The unit sits on the hitting surface beside the ball rather than overhead, and you give up the overhead unit’s third camera and larger hitting zone — Uneekor publishes 28″ × 21″ for the EYE XO2 against 12″ × 8″ for the EYE MINI, which reads club data with club stickers. Carl’s publishes 9′H for that build against 10′H for this one.'
            : 'The overhead build fits where this one does not. It asks a foot more of the ceiling for the launch monitor and in return keeps the floor clear and measures a larger hitting zone.';
          b.unlocks.unshift({ id: 'switch', text: txt, result: other.result, switchTo: olm.buildKey });
        }
      });
      var v = 'no';
      out.builds.forEach(function (b) {
        if (b.result && b.result.verdict === 'fits') v = 'fits';
        else if (b.result && b.result.verdict === 'reduced' && v !== 'fits') v = 'reduced';
        else if (!b.result && b.unlocks.length && v === 'no') v = 'change';
        if (b.result && b.result.conditional) out.conditional = true;
      });
      out.verdict = v;
      return out;
    }

    // ---------- envelope ----------
    function envelopeFor(s, b) {
      var r = b.result; if (!r) return null;
      var m = r.m, enc = r.enc, lm = r.lm;
      var matSize = pickMat(s, r);
      return {
        schemaVersion: '1.0',
        room: { widthIn: s.w, lengthIn: s.l, ceilingMinInZoneIn: Math.min(m.ceilEnc.avail, m.ceilSwing.avail, m.ceilDev ? m.ceilDev.avail : s.c), obstructions: s.obs, golfers: s.golfers.map(function (g) { return { heightIn: g.h, handedness: g.hand }; }) },
        build: b.assembled ? 'assembled' : lm.buildKey,
        buildSource: b.assembled ? 'assembled' : 'curated',
        screen: b.screen ? { id: b.screen.id, name: b.screen.name } : null,
        verdict: r.verdict === 'fits' ? 'fits' : r.verdict === 'reduced' ? 'fits_reduced' : 'no_fit',
        swingTestPassed: s.swingTest,
        envelope: {
          enclosure: { id: enc.id, family: encFamily(enc), depthFt: enc.depthFt || null, vendorSize: enc.label, outerWIn: enc.outerWIn, outerHIn: enc.outerHIn, frameDepthIn: enc.frameDepthIn, floorDepthIn: enc.floorDepthIn, screenWIn: enc.viewableWIn, screenHIn: enc.viewableHIn },
          hittingPosition: { setbackFromScreenIn: TEE, lateralOffsetFromCentreIn: m.width.offset ? null : 0, reason: m.width.offset ? 'offset hitting area — Carl’s 10 ft minimum; exact offset set at installation' : (r.both ? 'centered — both handednesses present' : 'centered') },
          clearances: { rearOfScreenIn: R.rearOfScreen.recIn, aboveSwingIn: null, leadSideIn: R.swingRadiusIn, trailSideIn: R.swingRadiusIn, behindGolferIn: R.behindTee.recIn },
          projector: { id: r.proj.id, mountDistanceFromScreenIn: round1(m.proj.t), throwDistanceRangeIn: [round1(m.proj.tMin), round1(m.proj.tMax)], lensRule: m.proj.lensRule, maxLensHeightIn: m.proj.maxLens == null ? null : round1(m.proj.maxLens), requiredDropIn: m.proj.reqDrop == null ? null : round1(m.proj.reqDrop), behindTeeIn: round1(m.proj.behindTee), clearOfSwing: m.proj.clearOfSwing, mountDropRangeIn: r.proj.mountDropRangeIn },
          launchMonitor: lm.mountClass === 'overhead'
            ? { id: lm.id, mountClass: 'overhead', bracketAboveHittingSurfaceIn: lm.bracketAboveHittingSurfaceIn, forwardOfTeeIn: lm.forwardOfTeeIn, minFromScreenIn: lm.minFromScreenIn }
            : { id: lm.id, mountClass: lm.mountClass, position: lm.position, behindTeeMinIn: lm.behindTeeMinIn || null },
          mat: { id: MAT.id, sizeIn: [matSize.wIn, matSize.lIn], layout: matSize.layout, thicknessIn: MAT.thicknessIn }
        },
        margins: marginsList(r),
        unknowns: D.unknowns,
        prices: null
      };
    }
    function round1(v) { return Math.round(v * 10) / 10; }
    function pickMat(s, r) {
      if (r.matChoice) return r.matChoice;
      var centered = !r.m.width.offset;
      var sizes = MAT.sizes.filter(function (z) { return z.layout === (centered ? 'centered' : 'offset'); });
      sizes.sort(function (a, b) { return (b.wIn * b.lIn) - (a.wIn * a.lIn); });
      for (var i = 0; i < sizes.length; i++) if (sizes[i].lIn <= s.w && sizes[i].wIn <= s.l) return sizes[i];
      return sizes[sizes.length - 1];
    }
    function matsThatFit(s, r) {
      var centered = !r.m.width.offset;
      return MAT.sizes.filter(function (z) { return z.layout === (centered ? 'centered' : 'offset') && z.lIn <= s.w && z.wIn <= s.l; })
        .sort(function (a, b) { return (b.wIn * b.lIn) - (a.wIn * a.lIn); });
    }
    function marginsList(r) {
      var m = r.m, out = [];
      out.push({ constraint: 'ceiling.enclosure', availableIn: m.ceilEnc.avail, requiredIn: m.ceilEnc.req, marginIn: round1(m.ceilEnc.margin) });
      if (m.ceilDev) out.push({ constraint: 'ceiling.device', availableIn: m.ceilDev.avail, requiredIn: m.ceilDev.req, requiredRecIn: m.ceilDev.reqRec, marginIn: round1(m.ceilDev.margin), toleranceIn: m.ceilDev.tol });
      out.push({ constraint: 'ceiling.swing', availableIn: m.ceilSwing.avail, publishedMinIn: m.ceilSwing.req, publishedRecIn: m.ceilSwing.reqRec, band: m.ceilSwing.band });
      out.push({ constraint: 'width', availableIn: m.width.avail, requiredIn: m.width.req, requiredRecIn: m.width.reqRec, marginIn: round1(m.width.margin) });
      if (m.lane) out.push({ constraint: 'width.enclosure', availableIn: m.lane.avail, requiredIn: m.lane.req, requiredRecIn: m.lane.reqRec, marginIn: round1(m.lane.margin), derived: true });
      out.push({ constraint: 'depth', availableIn: m.depth.avail, requiredIn: m.depth.req, requiredRecIn: m.depth.reqRec, marginIn: round1(m.depth.margin) });
      return out;
    }

    // ---------- render ----------
    var state = null, lastEval = null;

    function verdictCopy(ev, s) {
      var t = {};
      if (ev.verdict === 'fits') { t.eyebrow = 'Your room'; t.title = 'Your room takes a full build at the published recommended clearances.'; }
      else if (ev.verdict === 'reduced') { t.eyebrow = 'Your room'; t.title = 'Your room takes a build at the published minimums — here is what tightens.'; }
      else if (ev.verdict === 'change') { t.eyebrow = 'Your room'; t.title = 'Your room is close. One change makes it fit.'; }
      else { t.eyebrow = 'Your room'; t.title = 'As entered, this room does not take a build from the current enclosure line.'; }
      if (ev.verdict !== 'no' && ev.conditional) t.sub = 'One figure is yours to confirm — no manufacturer publishes how much ceiling a particular golfer’s swing needs. The swing test below is how Carl’s Place resolves it, and the tool will not commit on ceiling until you have.';
      else if (ev.verdict === 'no') t.sub = 'Every figure below is the manufacturer’s. Carl’s Place also builds enclosures to custom dimensions, which is a consultation rather than a calculator — bring the room and the tool’s numbers.';
      else if (ev.verdict === 'change') t.sub = 'Each card names what stops it and what would change the answer. Make the change in the form above and check again — the drawing appears once a build fits.';
      else t.sub = 'Both builds are shown with your room’s own numbers against each. Neither is the default; the one you choose feeds the drawing and the consultation.';
      return t;
    }

    function pill(r, b) {
      var cls, txt;
      if (!r) { cls = b.unlocks.length ? 'change' : 'no'; txt = b.unlocks.length ? 'Fits with one change' : 'Does not fit as entered'; }
      else if (r.conditional) { cls = 'cond'; txt = (r.verdict === 'fits' ? 'Fits' : 'At minimums') + ' — swing test pending'; }
      else if (r.verdict === 'fits') { cls = 'fits'; txt = 'Fits at recommended'; }
      else { cls = 'reduced'; txt = 'Fits at minimums'; }
      return el('span', { class: 'precision-fit__pill precision-fit__pill--' + cls, text: txt });
    }

    function kv(k, v, sub, cls) {
      var p = el('p', { class: 'v' + (cls ? ' ' + cls : '') }, [v]);
      if (sub) p.appendChild(el('small', { text: sub }));
      return el('li', {}, [el('span', { class: 'k', text: k }), p]);
    }

    function projText(pm) {
      var where = 'Mounts ' + ftin(pm.t) + ' from the screen — ' + (pm.behindTee >= 0 ? ftin(pm.behindTee) + ' behind the tee' : ftin(-pm.behindTee) + ' in front of the tee') + '.';
      if (pm.lensRule === 'shift') return where + ' Lens sits up to ' + ftin(pm.maxLens) + ' above the floor, so it hangs about ' + inchesOnly(pm.reqDrop) + ' below your ceiling.';
      if (pm.lensRule === 'fixed') return where + ' With no lens shift the lens sits at ' + ftin(pm.maxLens) + ' above the floor — about ' + inchesOnly(pm.reqDrop) + ' below your ceiling.';
      return where + ' The maker does not publish a projection offset, so the lens height is not stated here.';
    }
    function projNotes(pm, P) {
      var out = [];
      if (!pm.clearOfSwing) out.push('The projector lands ' + (pm.behindTee >= 0 ? ftin(pm.behindTee) + ' behind' : ftin(-pm.behindTee) + ' in front of') + ' the tee. BenQ recommends 2–3 ft behind the hitting area, out of the swing path. A larger screen would push it back — the tool has already chosen the largest that fits this room — so the mount height and drop matter here: confirm them with your professional installer.');
      if (pm.lensRule === 'shift' && pm.reqDrop > 12) out.push('To reach the screen the projector’s lens can sit no higher than ' + ftin(pm.maxLens) + ' (' + P.vendor + ' publishes ' + Math.round(P.offsetPct * 100) + '% offset and ' + Math.round(P.vShiftPct * 100) + '% vertical lens shift), which means a mount drop of roughly ' + inchesOnly(pm.reqDrop) + ' below your ceiling. ' + P.vendor + ' does not publish the drop range of its ceiling mount; that is confirmed at installation.');
      if (pm.lensRule === 'fixed' && pm.reqDrop > 12) out.push('This projector has no lens shift: ' + P.vendor + ' publishes a ' + Math.round(P.offsetPct * 100) + '% offset, which puts the lens ' + ftin(pm.maxLens) + ' above the floor for this opening — a mount drop of roughly ' + inchesOnly(pm.reqDrop) + ' below your ceiling.');
      if (pm.lensRule === 'unknown') out.push(P.vendor + ' does not publish a projection offset for the ' + P.name + ', so the tool cannot state its lens height or mount drop. Its throw distance is shown; the rest is confirmed at installation.');
      if (P.centreOnly) out.push('Carl’s Place notes the ' + P.name + ' has vertical keystone only and has to be mounted on the screen’s centreline.');
      return out;
    }

    function renderBuild(s, b, ev) {
      var r = b.result, lm = b.lm;
      var card = el('article', { class: 'precision-fit__build', 'data-build': lm.buildKey });
      card.appendChild(el('div', { class: 'precision-fit__build-head' }, [
        el('h4', { class: 'precision-fit__build-title', text: lm.buildName }),
        pill(r, b)
      ]));
      var ideal = lm.carlsIdealRoomIn;
      card.appendChild(el('p', { class: 'precision-fit__build-room', text: lm.name + ' — ' + lm.position + ' Carl’s Place publishes ' + ftin(ideal.h) + ' H × ' + ftin(ideal.w) + ' W × ' + ftin(ideal.d) + ' D as the ideal room for this launch monitor.' }));

      if (r) {
        var m = r.m, enc = r.enc, mat = pickMat(s, r);
        var P = r.proj;
        var st = strip([[lm.image, lm.name], [P.image, P.name], [encImage(enc), encName(enc).replace('Carl’s Place ', 'Carl’s ')], [MAT.image, 'HotShot mat']]);
        if (st) card.appendChild(st);
        var list = el('ul', { class: 'precision-fit__kv' });
        list.appendChild(kv('Enclosure', encName(enc), 'Viewable ' + inchesOnly(enc.viewableHIn) + ' × ' + inchesOnly(enc.viewableWIn) + ' · frame ' + ftin(enc.outerHIn) + ' tall, ' + ftin(enc.outerWIn) + ' wide, ' + encDepthText(enc) + '. ' + (b.assembled ? 'Your choice in Assemble your own.' : 'The largest in the line that fits this room.')));
        list.appendChild(kv('Launch monitor', lm.name, lm.mountClass === 'overhead' ? 'Bracket ' + ftin(lm.bracketAboveHittingSurfaceIn.min) + '–' + ftin(lm.bracketAboveHittingSurfaceIn.max) + ' above the hitting surface, ' + fwdText(lm) + '.' : lm.mountClass === 'rear' ? lm.position + ' Asks depth of the room, not height.' : lm.position + ' Asks nothing of the ceiling.'));
        list.appendChild(kv('Projector', P.name, projText(m.proj)));
        list.appendChild(kv('Impact screen', 'Carl’s Place — four grades', 'Standard to High-Contrast Gray. Choose one in Assemble your own below, or settle it on the call. It does not change whether the room fits.'));
        list.appendChild(kv('Hitting mat', MAT.name, ftin(mat.wIn) + ' × ' + ftin(mat.lIn) + ', ' + mat.layout + ' hitting area, 1¾″ thick.'));
        list.appendChild(kv('Simulator PC and software', 'Specified at the consultation', 'Software is named and cited to its publisher, not sold here. The launch monitor ships with its own maker’s software in the box.'));
        var inIt = fold('What is in it', encName(enc).replace('Carl’s Place ', 'Carl’s ') + ' · ' + lm.name + ' · ' + P.name, list);   // D100: closed on every screen size

        var mg = el('ul', { class: 'precision-fit__kv' });
        mg.appendChild(kv('Ceiling — frame', fmtMargin(m.ceilEnc.margin), 'You have ' + ftin(m.ceilEnc.avail) + ' where the frame stands; the ' + enc.label + ' frame is ' + ftin(enc.outerHIn) + ' tall.', marginClass(m.ceilEnc.margin)));
        if (m.ceilDev) mg.appendChild(kv('Ceiling — device', fmtMargin(m.ceilDev.margin), 'You have ' + ftin(m.ceilDev.avail) + ' over the launch monitor. It needs ' + ftin(m.ceilDev.req) + ' at least (9 ft bracket height plus the mat), up to ' + inchesOnly(m.ceilDev.tol) + ' more depending on where the bracket is measured to, and Carl’s publishes ' + ftin(m.ceilDev.reqRec) + ' as the ideal.', marginClass(m.ceilDev.margin, m.ceilDev.marginRec < 0)));
        var sb = m.ceilSwing.band;
        mg.appendChild(kv('Ceiling — swing', sb === 'rec' ? 'At Carl’s recommended 10 ft+' : sb === 'tested' ? 'Confirmed by your swing test' : sb === 'conditional' ? 'Within Carl’s 8–10 ft band — confirm with the swing test' : 'Below Carl’s published 8 ft minimum', 'You have ' + ftin(m.ceilSwing.avail) + ' over the swing. No manufacturer publishes a golfer-specific figure.', sb === 'rec' || sb === 'tested' ? 'precision-fit__margin--ok' : sb === 'conditional' ? 'precision-fit__margin--min' : 'precision-fit__margin--neg'));
        mg.appendChild(kv('Width', fmtMargin(m.width.margin), (m.width.offset ? 'Offset hitting position — Carl’s 10 ft minimum. Centered play for both handednesses needs 14 ft.' : 'Centered hitting position. Carl’s publishes 14 ft for centered play.') + ' The ' + enc.label + ' frame is ' + ftin(enc.outerWIn) + ' wide.', marginClass(m.width.margin, m.width.marginRec < 0)));
        if (m.lane) mg.appendChild(kv('Width inside the enclosure', fmtMargin(m.lane.margin), 'At ' + encDepthText(enc) + ' the frame reaches past the tee, so the swing happens between its sidewalls — ' + ftin(enc.outerWIn) + ' across. Carl’s publishes 10 ft with an offset hitting area and 14 ft for centered play as room widths; applying them to the frame is Precision’s derivation, not a Carl’s figure.', marginClass(m.lane.margin, m.lane.marginRec < 0)));
        mg.appendChild(kv('Length', fmtMargin(m.depth.margin), (m.depth.encGoverns ? 'The ' + encDepthText(enc) + ' frame plus Carl’s 1 ft behind the screen sets the minimum here — ' + ftin(m.depth.req) + '. ' : 'Carl’s: 1 ft behind the screen, 10–12 ft screen to tee, 4 ft behind the tee at minimum and 7 ft recommended. ') + 'You have ' + ftin(m.depth.avail) + '.', marginClass(m.depth.margin, m.depth.marginRec < 0)));
        var hint = 'Ceiling ' + fmtMargin(m.ceilEnc.margin).replace(' to spare', '') + ' · width ' + fmtMargin(m.width.margin).replace(' to spare', '') + ' · length ' + fmtMargin(m.depth.margin).replace(' to spare', '');
        var gives = el('div', { class: 'precision-fit__gives' }, [mg]);   // D100: margins and the notes share one closed fold

        var notes = [];
        projNotes(m.proj, P).forEach(function (t) { notes.push(t); });
        if (m.lane) notes.push('At ' + encDepthText(enc) + ' the Pro enclosure’s ceiling fabric runs over the hitting area. Carl’s states that the Pro frame carries mounted projectors and overhead launch monitors — on the front bar or an optional crossbar — and publishes no mounting height for them inside the enclosure. Confirm it with Carl’s for your unit before the frame is cut.');
        if (r.verdict === 'reduced') {
          var tight = [];
          if (m.width.marginRec < 0) tight.push('width');
          if (m.lane && m.lane.marginRec < 0) tight.push('width inside the enclosure');
          if (m.depth.marginRec < 0) tight.push('length');
          if (m.ceilDev && m.ceilDev.marginRec < 0) tight.push('ceiling over the launch monitor');
          if (tight.length) notes.push('This build sits at Carl’s published minimums rather than their recommendation on ' + tight.join(', ') + '. That is a real build, not a compromise the tool invented — but it is the difference between comfortable and tight, and it is worth walking through on the call.');
        }
        if (notes.length) gives.appendChild(el('div', {}, [el('p', { class: 'precision-fit__eyebrow', text: 'Worth knowing' }), el('ul', { class: 'precision-fit__notes' }, notes.map(function (t) { return el('li', { text: t }); }))]));

        var choose = el('button', { type: 'button', class: 'precision-fit__choose', text: 'Use this build for the drawing and the call', 'aria-pressed': String(s.selected === lm.buildKey) });
        choose.addEventListener('click', function () { state.selected = lm.buildKey; render(state, lastEval); });
        // D100: head, room line, strip and the two actions stay visible; everything else folds, closed
        card.appendChild(el('div', { class: 'precision-fit__build-actions' }, [choose, seeItButton(b)]));
        card.appendChild(inIt);
        card.appendChild(fold('What your room gives it', hint, gives));
        card.appendChild(fold('Buy this build', 'Each line resolved to a product, with the total', renderBuy(b)));
      } else {
        var f = b.failing, why = [];
        if (f) {
          var fm = f.m;
          f.fails.forEach(function (k) {
            if (k === 'ceilEnc') why.push('Even the smallest enclosure in the line, the ' + f.enc.label + ', has a ' + ftin(f.enc.outerHIn) + ' frame and you have ' + ftin(fm.ceilEnc.avail) + ' where it stands.');
            if (k === 'ceilDev') why.push('The overhead launch monitor needs ' + ftin(fm.ceilDev.req) + ' over the tee at the very least and you have ' + ftin(fm.ceilDev.avail) + '.');
            if (k === 'ceilSwing') why.push(fm.ceilSwing.band === 'failed' ? 'Your swing test did not clear. ' + D.swingTest.limited : 'You have ' + ftin(fm.ceilSwing.avail) + ' over the swing, below Carl’s published 8 ft minimum.');
            if (k === 'width') why.push('Width: you have ' + ftin(fm.width.avail) + ' and this needs ' + ftin(fm.width.req) + (fm.width.both ? ' for centered play serving both handednesses' : ' with an offset hitting area') + '.');
            if (k === 'lane') why.push('Width inside the enclosure: at ' + encDepthText(f.enc) + ' the frame reaches past the tee and is ' + ftin(f.enc.outerWIn) + ' across, below Carl’s ' + ftin(fm.lane.req) + (fm.lane.both ? ' for centered play serving both handednesses' : ' with an offset hitting area') + '.');
            if (k === 'depth') why.push('Length: you have ' + ftin(fm.depth.avail) + ' and Carl’s minimum is ' + ftin(fm.depth.req) + ' — 1 ft behind the screen, 10 ft to the tee, 4 ft behind it.');
            if (k === 'proj') why.push('The projector cannot be placed inside the room at a distance that fills this screen.');
            if (k === 'projHeight') why.push('This projector has no lens shift and its published offset puts the lens above your ceiling on this opening.');
          });
        }
        card.appendChild(el('div', {}, [el('p', { class: 'precision-fit__eyebrow', text: 'What stops it' }), el('ul', { class: 'precision-fit__notes' }, why.map(function (t) { return el('li', { text: t }); }))]));
        if (b.unlocks.length) {
          card.appendChild(el('div', {}, [el('p', { class: 'precision-fit__eyebrow', text: 'What would change the answer' }), el('ul', { class: 'precision-fit__notes' }, b.unlocks.map(function (u) { return el('li', { text: u.text }); }))]));
        }
      }
      return card;
    }

    function renderSwing(s, ev) {
      swingEl.textContent = '';
      // Shown whenever the ceiling over the swing sits in Carl's 8–10 ft band — whether or not a
      // build currently passes — so a "did not clear" answer can always be revisited.
      var cs = ceilingIn(s, [Math.max(0, TEE - R.swingRadiusIn), TEE + R.swingRadiusIn]);
      var inBand = cs >= R.ceiling.minIn && cs < R.ceiling.recIn;
      if (!inBand) { swingEl.hidden = true; return; }
      swingEl.hidden = false;
      swingEl.appendChild(el('p', { class: 'precision-fit__eyebrow', text: 'The one figure that is yours' }));
      swingEl.appendChild(el('p', { text: 'Over the swing your ceiling is ' + ftin(cs) + ' — inside the 8–10 ft band where Carl’s Place says the answer depends on your height, your swing and your club. No manufacturer publishes that number. Carl’s instruction is the honest one:' }));
      var q = el('blockquote', {}, [D.swingTest.quote + ' ' + D.swingTest.quote2]);
      q.appendChild(el('cite', { text: '— Carl’s Place, Measuring Your Space for an Indoor Golf Simulator' }));
      swingEl.appendChild(q);
      var yes = el('button', { type: 'button', class: 'precision-fit__btn', text: 'A full driver swing cleared', 'aria-pressed': String(s.swingTest === true) });
      var no = el('button', { type: 'button', class: 'precision-fit__btn', text: 'It did not clear', 'aria-pressed': String(s.swingTest === false) });
      yes.addEventListener('click', function () { state.swingTest = true; run(); });
      no.addEventListener('click', function () { state.swingTest = false; run(); });
      swingEl.appendChild(el('div', { class: 'precision-fit__swing-actions' }, [yes, no]));
      if (s.swingTest === false) swingEl.appendChild(el('p', { text: D.swingTest.limited + ' That is a conversation about clubs and swing rather than about equipment, and it belongs on the call.' }));
    }

    // ---------- side elevation ----------
    var NS = 'http://www.w3.org/2000/svg';
    function svgEl(tag, attrs) { var n = document.createElementNS(NS, tag); Object.keys(attrs || {}).forEach(function (k) { n.setAttribute(k, attrs[k]); }); return n; }
    function tallest(s) { return s.golfers.reduce(function (m, g) { return Math.max(m, g.h); }, 0) || 70; }
    function callout(svg, cx, cy, n, green) {
      var c = svgEl('circle', { cx: cx, cy: cy, r: '5.5', fill: '#f4f3ef', stroke: green ? '#1f4b36' : '#14181a', 'stroke-width': '0.8', 'vector-effect': 'non-scaling-stroke' });
      var t = svgEl('text', { x: cx, y: cy + 2.2, 'text-anchor': 'middle', 'font-size': '6.2', 'font-family': 'inherit', fill: green ? '#1f4b36' : '#14181a' }); t.textContent = String(n);
      svg.appendChild(c); svg.appendChild(t);
    }
    // A golfer at address, seen from the side wall — drawn at the tallest height entered. Deliberately
    // NOT at the top of the backswing: the clubhead's peak is the figure no manufacturer publishes.
    function golferElevation(svg, gx, base, H, y, ink) {
      var r = H * 0.062, headY = y(base + H - r);
      var shoulderY = y(base + H * 0.80), hipY = y(base + H * 0.50), footY = y(base), handY = y(base + H * 0.40);
      var g = svgEl('g', { fill: 'rgba(20,24,26,0.10)', stroke: ink, 'stroke-width': '0.8', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'vector-effect': 'non-scaling-stroke' });
      g.appendChild(svgEl('circle', { cx: gx, cy: headY, r: r }));
      g.appendChild(svgEl('path', { d: 'M ' + (gx - H * 0.11) + ' ' + shoulderY + ' L ' + (gx + H * 0.11) + ' ' + shoulderY + ' L ' + (gx + H * 0.07) + ' ' + hipY + ' L ' + (gx - H * 0.07) + ' ' + hipY + ' Z' }));
      g.appendChild(svgEl('path', { d: 'M ' + (gx - H * 0.05) + ' ' + hipY + ' L ' + (gx - H * 0.08) + ' ' + footY + ' M ' + (gx + H * 0.05) + ' ' + hipY + ' L ' + (gx + H * 0.08) + ' ' + footY, fill: 'none' }));
      g.appendChild(svgEl('path', { d: 'M ' + (gx - H * 0.11) + ' ' + shoulderY + ' L ' + (gx - H * 0.03) + ' ' + handY + ' M ' + (gx + H * 0.11) + ' ' + shoulderY + ' L ' + (gx - H * 0.03) + ' ' + handY, fill: 'none' }));
      svg.appendChild(g);
      return { handX: gx - H * 0.03, handY: handY, headY: headY };
    }

    function renderDrawing(s, b) {
      svgWrap.textContent = ''; legendEl.textContent = '';
      drawingBuildEl.textContent = b.assembled ? 'your assembled build' : b.lm.buildName;
      var r = b.result; if (!r) return;
      var enc = r.enc, m = r.m, lm = b.lm;
      var C = s.c, L = s.l, H = tallest(s);
      var PAD = 30, LEFT = 44, BOT = 34;
      var W = L + LEFT + PAD, Hv = C + PAD + BOT;
      var svg = svgEl('svg', { viewBox: '0 0 ' + W + ' ' + Hv, role: 'img', 'aria-label': 'Side elevation of the room with the ' + (b.assembled ? 'assembled build' : lm.buildName) + ' drawn to scale' });
      var ink = '#14181a', green = '#1f4b36';
      var X0 = LEFT, Y0 = PAD;
      var x = function (d) { return X0 + d; }, y = function (h) { return Y0 + (C - h); };
      var hair = { stroke: ink, 'stroke-width': '0.8', fill: 'none', 'vector-effect': 'non-scaling-stroke' };
      function line(x1, y1, x2, y2, extra) { svg.appendChild(svgEl('line', Object.assign({ x1: x1, y1: y1, x2: x2, y2: y2 }, hair, extra || {}))); }
      function rect(x1, y1, w, h, extra) { svg.appendChild(svgEl('rect', Object.assign({ x: x1, y: y1, width: w, height: h }, hair, extra || {}))); }
      function text(tx, ty, str, extra) { var t = svgEl('text', Object.assign({ x: tx, y: ty, 'font-size': '6', fill: ink, 'font-family': 'inherit' }, extra || {})); t.textContent = str; svg.appendChild(t); }

      // swing zone — the band where the ceiling is checked (Carl's 7 ft either side of the tee). A band,
      // not an arc: Carl's 7 ft is around the golfer on the floor, and nobody publishes the arc's height.
      var sr = R.swingRadiusIn, zx0 = Math.max(0, TEE - sr), zx1 = Math.min(L, TEE + sr);
      rect(x(zx0), y(C), zx1 - zx0, C, { fill: 'rgba(31,75,54,0.06)', stroke: green, 'stroke-dasharray': '4 3', 'stroke-width': '1' });
      // room
      line(x(0), y(C), x(0), y(0)); line(x(L), y(C), x(L), y(0));
      line(x(0), y(C), x(L), y(C)); line(x(0), y(0), x(L), y(0), { 'stroke-width': '1.4' });
      // obstructions
      s.obs.forEach(function (o) { rect(x(o.d - 6), y(C), 12, C - o.clear, { fill: 'rgba(20,24,26,0.18)', stroke: 'none' }); });
      // enclosure — frame + screen face
      var rear = R.rearOfScreen.recIn;
      rect(x(rear), y(enc.outerHIn), enc.floorDepthIn, enc.outerHIn);
      line(x(rear), y(enc.outerHIn), x(rear), y(0), { 'stroke-width': '2.2' });
      // mat + tee
      var mat = pickMat(s, r);
      rect(x(TEE - mat.wIn / 2), y(MAT.thicknessIn), mat.wIn, MAT.thicknessIn, { fill: 'rgba(20,24,26,0.08)' });
      svg.appendChild(svgEl('circle', { cx: x(TEE), cy: y(MAT.thicknessIn + 0.8), r: '1.6', fill: ink }));
      // golfer at address, standing beside the ball
      var gx = x(TEE + 11);
      var gf = golferElevation(svg, gx, MAT.thicknessIn, H, y, ink);
      line(gf.handX, gf.handY, x(TEE + 1), y(MAT.thicknessIn + 1), { 'stroke-width': '0.9' });
      // launch monitor
      var lmTop, lmX = lm.mountClass === 'rear' ? TEE + (lm.behindTeeMinIn || 96) : TEE - 14;
      var P = r.proj || PROJ;
      if (lm.mountClass === 'overhead') {
        lmTop = MAT.thicknessIn + lm.bracketAboveHittingSurfaceIn.min + lm.bodyIn.assembledIn;
        rect(x(TEE - lm.forwardOfTeeIn - 6), y(Math.min(lmTop, C)), 12, lm.bodyIn.assembledIn, { fill: ink });
        line(x(TEE - lm.forwardOfTeeIn), y(C), x(TEE - lm.forwardOfTeeIn), y(Math.min(lmTop, C)), { 'stroke-dasharray': '2 2' });
      } else {
        rect(x(lmX), y(MAT.thicknessIn + lm.bodyIn.h), lm.bodyIn.d, lm.bodyIn.h, { fill: ink });
      }
      // projector — lens height from the rule; unknown offset draws it at the ceiling, dashed
      var lensY = m.proj.maxLens == null ? C - P.bodyIn.h / 2 : Math.min(m.proj.maxLens, C - P.bodyIn.h / 2);
      rect(x(m.proj.t - P.bodyIn.d / 2), y(lensY + P.bodyIn.h / 2), P.bodyIn.d, P.bodyIn.h, m.proj.maxLens == null ? { fill: 'rgba(20,24,26,0.35)', 'stroke-dasharray': '2 2' } : { fill: ink });
      if (C - (lensY + P.bodyIn.h / 2) > 0.5) line(x(m.proj.t), y(C), x(m.proj.t), y(lensY + P.bodyIn.h / 2), { 'stroke-dasharray': '2 2' });
      // dimensions
      var fy = y(0);
      line(x(0), fy + 14, x(TEE), fy + 14, { 'stroke-width': '0.6' }); line(x(0), fy + 10, x(0), fy + 18, { 'stroke-width': '0.6' }); line(x(TEE), fy + 10, x(TEE), fy + 18, { 'stroke-width': '0.6' });
      text(x(TEE / 2), fy + 26, ftin(TEE) + ' screen to tee', { 'text-anchor': 'middle' });
      line(x(TEE), fy + 14, x(L), fy + 14, { 'stroke-width': '0.6', 'stroke-dasharray': '2 2' }); line(x(L), fy + 10, x(L), fy + 18, { 'stroke-width': '0.6' });
      text(x(TEE + (L - TEE) / 2), fy + 26, ftin(L - TEE) + ' behind', { 'text-anchor': 'middle' });
      line(X0 - 16, y(0), X0 - 16, y(C), { 'stroke-width': '0.6' }); line(X0 - 20, y(0), X0 - 12, y(0), { 'stroke-width': '0.6' }); line(X0 - 20, y(C), X0 - 12, y(C), { 'stroke-width': '0.6' });
      text(X0 - 20, y(C / 2), ftin(C), { 'text-anchor': 'end', transform: 'rotate(-90 ' + (X0 - 20) + ' ' + y(C / 2) + ')' });
      // callouts — numbered to the legend below
      callout(svg, x(rear + 10), y(enc.outerHIn) - 8, 1);
      if (lm.mountClass === 'overhead') callout(svg, x(TEE - lm.forwardOfTeeIn) - 12, y(Math.min(lmTop, C)) + 3, 2); else callout(svg, x(lmX) - 8, y(MAT.thicknessIn + lm.bodyIn.h + 6), 2);
      callout(svg, x(m.proj.t) + 14, y(lensY), 3);
      callout(svg, x(TEE - mat.wIn / 2) - 8, y(8), 4);
      callout(svg, gx + H * 0.16, gf.headY, 5);
      callout(svg, x(zx1) - 8, y(C) + 9, 6, true);
      if (s.obs.length) callout(svg, x(s.obs[0].d) + 12, y(C) + 6, 7);
      svgWrap.appendChild(svg);

      var items = [
        ['Enclosure and impact screen — ' + encName(enc).replace('Carl’s Place ', 'Carl’s ') + ', frame ' + ftin(enc.outerHIn) + ' tall, ' + encDepthText(enc) + ', 1 ft off the back wall. The heavy line is the screen face.', ''],
        [lm.mountClass === 'overhead' ? 'Launch monitor — ' + lm.name + ', ceiling-mounted, bracket ' + ftin(lm.bracketAboveHittingSurfaceIn.min) + '+ above the mat, ' + fwdText(lm) + '.' : lm.mountClass === 'rear' ? 'Launch monitor — ' + lm.name + ', radar ' + ftin(lm.behindTeeMinIn || 96) + ' behind the tee.' : 'Launch monitor — ' + lm.name + ', on the hitting surface beside the ball.', ''],
        ['Projector — ' + (r.proj || PROJ).name + ', ' + ftin(m.proj.t) + ' from the screen' + (m.proj.maxLens == null ? ' (lens height not published).' : ', lens no higher than ' + ftin(m.proj.maxLens) + '.'), ''],
        ['Hitting mat and tee — ' + ftin(mat.wIn) + ' deep, ' + ftin(mat.lIn) + ' across, 1¾″ thick. The tee is ' + ftin(TEE) + ' from the screen.', ''],
        ['Golfer at address — drawn at ' + ftin(H) + ', the tallest height you entered, standing at the tee facing you.', ''],
        ['Swing zone — 7 ft either side of the tee, from Carl’s Place. The ceiling is checked at its lowest point anywhere in this band. How high your club travels is the figure no one publishes, and yours to test.', 'is-green']
      ];
      if (s.obs.length) items.push(['Obstructions you entered, at their distance from the screen wall, drawn to the height of their underside.', '']);
      items.forEach(function (it) { legendEl.appendChild(el('li', { class: it[1], text: it[0] })); });
    }

    // ---------- assemble your own ----------
    function lmByKey(k) { return ALL_LM.filter(function (l) { return l.buildKey === k; })[0]; }
    function encById(id) {
      if (!id) return undefined;
      var parts = String(id).split('@'), base = D.enclosures.filter(function (e) { return e.id === parts[0]; })[0];
      if (!base) return undefined;
      return parts[1] ? withDepth(base, parts[1]) : base;
    }
    function matKey(z) { return z.wIn + 'x' + z.lIn; }

    function assembledBuild(s) {
      var a = s.assembled; if (!a) return null;
      var lm = lmByKey(a.lm), enc = encById(a.enc);
      if (!lm || !enc) return null;
      var r = evaluateBuild(s, lm, enc, { proj: projById(a.proj) });
      if (r.verdict === 'no') return null;
      var mats = matsThatFit(s, r);
      r.matChoice = mats.filter(function (z) { return matKey(z) === a.mat; })[0] || mats[0] || pickMat(s, r);
      var screen = D.screens.filter(function (x) { return x.id === a.screen; })[0] || D.screens[0];
      return { lm: lm, result: r, screen: screen, assembled: true, unlocks: [] };
    }
    function ensureAssembled(s, ev) {
      var first = ev.builds.filter(function (b) { return b.result; })[0];
      if (!first) { s.assembled = null; return; }
      var a = s.assembled;
      var valid = a && lmByKey(a.lm) && bestFor(s, lmByKey(a.lm)).best && encById(a.enc) && evaluateBuild(s, lmByKey(a.lm), encById(a.enc)).verdict !== 'no';
      if (!valid) s.assembled = { lm: first.lm.buildKey, enc: first.result.enc.id, screen: D.screens[0].id, mat: null, proj: PROJ.id };
      if (!s.assembled.proj) s.assembled.proj = PROJ.id;
    }
    function setAssembled(patch) {
      Object.keys(patch).forEach(function (k) { state.assembled[k] = patch[k]; });
      if (patch.lm) { var best = bestFor(state, lmByKey(patch.lm)).best; state.assembled.enc = best ? best.enc.id : null; state.assembled.mat = null; }
      if (patch.enc) state.assembled.mat = null;
      if (patch.proj) { var chk = evaluateBuild(state, lmByKey(state.assembled.lm), encById(state.assembled.enc), { proj: projById(patch.proj) }); if (chk.verdict === 'no') { var b2 = bestFor(state, lmByKey(state.assembled.lm), { proj: projById(patch.proj) }).best; state.assembled.enc = b2 ? b2.enc.id : state.assembled.enc; state.assembled.mat = null; } }
      state.selected = 'assembled';
      render(state, lastEval);
      var t = root.querySelector('[data-drawing] .precision-fit__eyebrow'); if (t) t.setAttribute('data-live', '1');
    }
    function opt(checked, name, pillEl, sub, onPick, img) {
      var b = el('button', { type: 'button', class: 'precision-fit__opt' + (img ? ' precision-fit__opt--img' : ''), role: 'radio', 'aria-checked': String(!!checked) });
      var nameRow = el('span', { class: 'precision-fit__opt-name' }, [el('span', { text: name })]);
      if (pillEl) nameRow.appendChild(pillEl);
      var body = el('span', {}, [nameRow]);
      if (sub) body.appendChild(el('span', { class: 'precision-fit__opt-sub', text: sub }));
      b.appendChild(el('span', { class: 'precision-fit__opt-dot', 'aria-hidden': 'true' }));
      if (img) b.appendChild(thumb(img, '', 'precision-fit__opt-thumb'));
      b.appendChild(body);
      b.addEventListener('click', onPick);
      return b;
    }
    function slot(title, note, children) {
      var card = el('section', { class: 'precision-fit__slot' });
      var head = el('div', { class: 'precision-fit__slot-head' }, [el('h4', { class: 'precision-fit__slot-title', text: title })]);
      card.appendChild(head);
      if (note) card.appendChild(el('p', { class: 'precision-fit__slot-note', text: note }));
      children.forEach(function (c) { if (c) card.appendChild(c); });
      return card;
    }
    function verdictPill(r) {
      var cls = r.conditional ? 'cond' : r.verdict === 'fits' ? 'fits' : 'reduced';
      var txt = r.verdict === 'fits' ? 'Fits at recommended' : 'Fits at minimums';
      if (r.conditional) txt = (r.verdict === 'fits' ? 'Fits' : 'At minimums') + ' — swing test pending';
      return el('span', { class: 'precision-fit__pill precision-fit__pill--' + cls, text: txt });
    }

    function renderAssemble(s, ev) {
      var panel = root.querySelector('[data-assemble]'); var slotsEl = root.querySelector('[data-slots]'); var foot = root.querySelector('[data-assemble-foot]');
      slotsEl.textContent = ''; foot.textContent = '';
      ensureAssembled(s, ev);
      if (!s.assembled) { panel.hidden = true; return; }
      panel.hidden = false;
      var a = s.assembled;
      var ab = assembledBuild(s);
      var lmSel = lmByKey(a.lm);

      // 1 · launch monitor — every unit in the catalogue, on the merits; an excluded one is stated, never offered
      var lmOpts = el('ul', { class: 'precision-fit__opts precision-fit__opts--2', role: 'radiogroup', 'aria-label': 'Launch monitor' });
      var excluded = [];
      var projSel = projById(a.proj);
      ALL_LM.forEach(function (lm) {
        var res = bestFor(s, lm, { proj: projSel });
        var ideal = lm.carlsIdealRoomIn;
        var roomTxt = ideal ? 'Carl’s ideal room ' + ftin(ideal.h) + ' H × ' + ftin(ideal.w) + ' W × ' + ftin(ideal.d) + ' D. ' : (lm.vendorCeilingIn ? lm.vendor + ' publishes a ' + ftin(lm.vendorCeilingIn.min) + (lm.vendorCeilingIn.max > lm.vendorCeilingIn.min ? '–' + ftin(lm.vendorCeilingIn.max) : '') + ' ceiling. ' : 'No room figure of its own — Carl’s general guide applies. ');
        var kind = lm.mountClass === 'overhead' ? 'Ceiling-mounted, ' + fwdText(lm) + '. ' : lm.mountClass === 'rear' ? 'Radar, ' + ftin(lm.behindTeeMinIn || 96) + ' behind the tee. ' : 'On the hitting surface. ';
        if (res.best) {
          var mm = res.best.m;
          var sub = kind + roomTxt + (mm.ceilDev ? 'Your ceiling gives the device ' + fmtMargin(mm.ceilDev.margin) + '.' : lm.mountClass === 'rear' ? 'Your room gives it ' + fmtMargin(mm.depth.margin) + ' of length.' : 'Asks nothing of the ceiling.');
          lmOpts.appendChild(el('li', {}, [opt(a.lm === lm.buildKey, lm.name, null, sub, function () { setAssembled({ lm: lm.buildKey }); }, lm.image)]));
        } else {
          var f = res.smallestFail, why = '';
          if (f && f.fails.indexOf('ceilDev') > -1) why = 'needs ' + ftin(f.m.ceilDev.req) + ' over the tee at the very least and you have ' + ftin(f.m.ceilDev.avail) + '.' + (ideal ? ' Carl’s publishes ' + ftin(ideal.h) + ' as the ideal room height for it.' : '');
          else if (f && f.fails.indexOf('width') > -1) why = 'needs ' + ftin(f.m.width.req) + ' of width for this household and you have ' + ftin(f.m.width.avail) + '.';
          else if (f && f.fails.indexOf('depth') > -1) why = 'needs ' + ftin(f.m.depth.req) + ' of length' + (f.m.depth.radar ? ' — ' + ftin(f.m.depth.behindMin) + ' of it behind the tee for the radar' : '') + ' and you have ' + ftin(f.m.depth.avail) + '.';
          else why = 'does not fit this room as entered.';
          excluded.push(lm.name + ' — ' + why);
        }
      });
      var lmChildren = [lmOpts];
      excluded.forEach(function (t) { lmChildren.push(el('p', { class: 'precision-fit__excluded', text: 'Not offered for this room: ' + t })); });
      slotsEl.appendChild(slot('Launch monitor', 'Every unit Precision supplies that fits this room is shown on the merits, the two curated builds first. None is the default.', lmChildren));

      if (!ab) { foot.appendChild(el('p', { class: 'precision-fit__excluded', text: 'No opening in the enclosure line fits this launch monitor in your room.' })); return; }

      // 2 · enclosure — only openings that fit, largest first
      var encOpts = el('ul', { class: 'precision-fit__opts', role: 'radiogroup', 'aria-label': 'Enclosure opening' });
      var encOut = [];
      enclosureChoices().forEach(function (enc) {
        var r = evaluateBuild(s, lmSel, enc, { proj: projSel });
        if (r.verdict === 'no') {
          var k = r.fails[0], m = r.m, why = k === 'ceilEnc' ? 'frame is ' + ftin(enc.outerHIn) + ' tall' : k === 'width' ? 'frame is ' + ftin(enc.outerWIn) + ' wide' : k === 'lane' ? 'frame is ' + ftin(enc.outerWIn) + ' across inside, below Carl’s ' + ftin(m.lane.req) + ' minimum' : k === 'proj' ? 'projector cannot sit inside the room' : k === 'projHeight' ? 'this projector’s lens would sit above your ceiling' : k === 'depth' ? 'room is too short' : 'does not fit';
          encOut.push((encFamily(enc) === 'pro' ? 'Pro ' : '') + enc.label + (enc.depthKey ? ' at ' + encDepthText(enc) : '') + ' (' + why + ')'); return;
        }
        var sub = 'Viewable ' + inchesOnly(enc.viewableHIn) + ' × ' + inchesOnly(enc.viewableWIn) + ' · frame ' + ftin(enc.outerHIn) + ' tall, ' + ftin(enc.outerWIn) + ' wide, ' + encDepthText(enc) + '. Ceiling ' + fmtMargin(r.m.ceilEnc.margin) + ' · width ' + fmtMargin(r.m.width.margin) + (r.m.lane ? ' · inside the frame ' + fmtMargin(r.m.lane.margin) : '') + ' · length ' + fmtMargin(r.m.depth.margin) + '.';
        encOpts.appendChild(el('li', {}, [opt(a.enc === enc.id, encName(enc) + (enc.depthKey ? ' · ' + encDepthText(enc) : ''), verdictPill(r), sub, function () { setAssembled({ enc: enc.id }); }, encImage(enc))]));
      });
      var encChildren = [encOpts];
      if (encOut.length) encChildren.push(el('p', { class: 'precision-fit__excluded', text: 'Left out for this room: ' + encOut.join(' · ') + '.' }));
      slotsEl.appendChild(slot('Enclosure opening', 'Largest first. Carl’s DIY line is five feet deep; the Pro line — 2-inch frame, foam included — is offered at 5, 8, 10 and 15 ft, with 10 and 15 ft on the 9 × 12, 10 × 13 and 10 × 15.5 only. Every depth that fits this room is listed.', encChildren));

      // 3 · impact screen — no dimensional effect, offered because the quote starts from a full spec
      var scOpts = el('ul', { class: 'precision-fit__opts precision-fit__opts--2', role: 'radiogroup', 'aria-label': 'Impact screen material' });
      D.screens.forEach(function (sc) {
        scOpts.appendChild(el('li', {}, [opt(a.screen === sc.id, sc.name, sc.noise ? el('span', { class: 'precision-fit__pill precision-fit__pill--cond', text: 'Noise dampening' }) : null, sc.guide, function () { setAssembled({ screen: sc.id }); }, sc.image)]));
      });
      slotsEl.appendChild(slot('Impact screen', D.screensNote + (encFamily(ab.result.enc) === 'pro' ? ' Carl’s offers the Pro enclosure in Premium and High-Contrast Gray only; a Standard or Preferred choice is left for you to settle on the product page.' : ''), [scOpts]));

      // 4 · projector — every unit in the catalogue, each with its numbers for the chosen opening
      var pOpts = el('ul', { class: 'precision-fit__opts precision-fit__opts--2', role: 'radiogroup', 'aria-label': 'Projector' });
      var pOut = [];
      D.projectors.forEach(function (pj) {
        var rr = evaluateBuild(s, lmSel, ab.result.enc, { proj: pj });
        var pm = rr.m.proj;
        if (rr.fails.indexOf('proj') > -1 || rr.fails.indexOf('projHeight') > -1) { pOut.push(pj.name + ' (' + (rr.fails.indexOf('proj') > -1 ? 'cannot sit inside the room at a distance that fills this screen' : 'its lens would sit above your ceiling on this opening') + ')'); return; }
        var sub = projText(pm) + (pm.clearOfSwing ? '' : ' Closer than BenQ’s recommended 2 ft behind the hitting area — mount height is confirmed at installation.') + (pj.centreOnly ? ' Vertical keystone only: mounted on the screen’s centreline.' : '');
        pOpts.appendChild(el('li', {}, [opt(a.proj === pj.id, pj.name, null, sub, function () { setAssembled({ proj: pj.id }); }, pj.image)]));
      });
      var pChildren = [pOpts];
      if (pOut.length) pChildren.push(el('p', { class: 'precision-fit__excluded', text: 'Left out for this opening: ' + pOut.join(' · ') + '.' }));
      slotsEl.appendChild(slot('Projector', 'Every projector Precision supplies, placed for the opening above. The image fills the screen’s height; the makers’ throw and offset figures set where each one hangs.', pChildren));

      // 5 · hitting mat — sizes that match the layout the room allows
      var mats = matsThatFit(s, ab.result);
      var mOpts = el('ul', { class: 'precision-fit__opts precision-fit__opts--2', role: 'radiogroup', 'aria-label': 'Hitting mat' });
      var chosen = ab.result.matChoice;
      mats.forEach(function (z) {
        mOpts.appendChild(el('li', {}, [opt(matKey(z) === matKey(chosen), ftin(z.wIn) + ' × ' + ftin(z.lIn) + ', ' + z.layout, null, (z.layout === 'centered' ? 'Centered hitting area — serves right- and left-handed golfers.' : 'Offset hitting area — for a single handedness in a narrower room.') + ' 1¾″ thick.', function () { setAssembled({ mat: matKey(z) }); }, MAT.image)]));
      });
      slotsEl.appendChild(slot('Hitting mat', MAT.name + '. ' + (ab.result.m.width.offset ? 'Your room takes an offset layout.' : 'Your room takes a centered layout.'), [mats.length ? mOpts : el('p', { class: 'precision-fit__excluded', text: 'No size in this layout fits the room as entered.' })]));

      // foot — verdict for the assembled build and the selector
      var use = el('button', { type: 'button', class: 'precision-fit__choose', text: 'Use this build for the drawing and the call', 'aria-pressed': String(s.selected === 'assembled') });
      use.addEventListener('click', function () { state.selected = 'assembled'; render(state, lastEval); });
      var encA = ab.result.enc;
      foot.appendChild(el('div', { class: 'precision-fit__build-head' }, [el('p', { class: 'precision-fit__build-room', text: 'Your assembled build — ' + lmSel.name + ' · ' + encName(encA).replace('Carl’s Place ', 'Carl’s ') + (encA.depthKey ? ' at ' + encDepthText(encA) : '') + ' · ' + ab.screen.name + ' screen · ' + ab.result.proj.name + ' · ' + ftin(chosen.wIn) + ' × ' + ftin(chosen.lIn) + ' mat' }), verdictPill(ab.result)]));
      foot.appendChild(el('div', { class: 'precision-fit__build-actions' }, [use, seeItButton(ab)]));
      if (ab.result.m.lane) {
        // the assembled build has no margins panel of its own, so the two step-4 notes for an enclosed Pro build sit here
        var lane = ab.result.m.lane;
        foot.appendChild(el('div', {}, [el('p', { class: 'precision-fit__eyebrow', text: 'Worth knowing' }), el('ul', { class: 'precision-fit__notes' }, [
          el('li', { text: 'Width inside the enclosure: ' + fmtMargin(lane.margin) + '. At ' + encDepthText(encA) + ' the frame reaches past the tee, so the swing happens between its sidewalls — ' + ftin(encA.outerWIn) + ' across. Carl’s publishes 10 ft with an offset hitting area and 14 ft for centered play as room widths; applying them to the frame is Precision’s derivation, not a Carl’s figure.' }),
          el('li', { text: 'At this depth the Pro enclosure’s ceiling fabric runs over the hitting area. Carl’s states that the Pro frame carries mounted projectors and overhead launch monitors — on the front bar or an optional crossbar — and publishes no mounting height for them inside the enclosure. Confirm it with Carl’s for your unit before the frame is cut.' })
        ])]));
      }
      foot.appendChild(fold('Buy this build', 'Each line resolved to a product, with the total', renderBuy(ab)));
    }

    // ---------- buy this build (catalogue join) ----------
    function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/×/g, 'x').replace(/\s+/g, ' ').trim(); }
    function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function optIndex(prod, name) { for (var i = 0; i < (prod.options || []).length; i++) if (norm(prod.options[i]) === norm(name)) return i; return -1; }
    function optValues(prod, name) {
      var i = optIndex(prod, name), seen = {}, out = [];
      if (i < 0) return out;
      prod.variants.forEach(function (v) { var val = v.options[i]; if (!seen[val]) { seen[val] = 1; out.push(val); } });
      return out;
    }
    function findVariant(prod, want) {
      // want: { optionName: value } — every option the product has must be present in want
      if (prod.variants.length === 1 && (!prod.options || prod.options.length === 0 || norm(prod.options[0]) === 'title')) return prod.variants[0];
      var idx = (prod.options || []).map(function (o) { return { i: optIndex(prod, o), name: o }; });
      var v = null;
      for (var k = 0; k < prod.variants.length; k++) {
        var cand = prod.variants[k], ok = true;
        for (var j = 0; j < idx.length; j++) {
          var wantVal = want[idx[j].name]; if (wantVal == null) { ok = false; break; }
          if (norm(cand.options[idx[j].i]) !== norm(wantVal)) { ok = false; break; }
        }
        if (ok) { v = cand; break; }
      }
      return v;
    }
    function buyLine(label, prod, fixed, chooseable, key) {
      // fixed: option values determined by the room; chooseable: options the buyer still picks here
      var li = el('li', { class: 'precision-fit__buy-line' });
      var head = el('div', { class: 'precision-fit__buy-head' }, [el('span', { class: 'precision-fit__buy-label', text: label })]);
      li.appendChild(head);
      if (!prod) {
        li.appendChild(el('p', { class: 'precision-fit__buy-note', text: 'Specified through the consultation.' }));
        return { node: li, variant: null, pending: false, consult: true };
      }
      var name = el('a', { class: 'precision-fit__buy-name', href: prod.url, text: prod.title });
      head.appendChild(name);
      if (prod.consultOnly) {
        li.appendChild(el('p', { class: 'precision-fit__buy-note', text: 'Quoted for your address — arranged through the consultation.' }));
        return { node: li, variant: null, pending: false, consult: true };
      }
      var want = {}; Object.keys(fixed).forEach(function (k) { want[k] = fixed[k]; });
      var sel = buySel[key] || (buySel[key] = {});
      var pending = false;
      var controls = el('div', { class: 'precision-fit__buy-controls' });
      (chooseable || []).forEach(function (ch) {
        var oname = typeof ch === 'string' ? ch : ch.name, keep = typeof ch === 'string' ? null : ch.keep;
        var values = optValues(prod, oname); if (keep) values = values.filter(keep); if (!values.length) return;
        var cur = sel[oname]; if (cur && values.indexOf(cur) < 0) cur = undefined;
        var id = 'buy-' + key + '-' + norm(oname).replace(/[^a-z0-9]+/g, '-');
        var select = el('select', { class: 'precision-fit__buy-select', id: id, 'aria-label': oname });
        select.appendChild(el('option', { value: '', text: 'Choose ' + oname.toLowerCase() + '…' }));
        values.forEach(function (val) { var o = el('option', { value: val, text: val }); if (cur === val) o.selected = true; select.appendChild(o); });
        select.addEventListener('change', function () { sel[oname] = select.value || undefined; var panel = li.closest('[data-buy-panel]'); if (panel) refreshBuy(panel); });
        controls.appendChild(el('label', { class: 'precision-fit__buy-field', for: id }, [el('span', { text: oname }), select]));
        if (cur) want[oname] = cur; else pending = true;
      });
      if (controls.childNodes.length) li.appendChild(controls);
      var fixedText = Object.keys(fixed).map(function (k) { return k + ': ' + fixed[k]; }).join(' · ');
      if (fixedText) li.appendChild(el('p', { class: 'precision-fit__buy-note', text: 'Set by your room — ' + fixedText + '.' }));
      var variant = pending ? null : findVariant(prod, want);
      var priceEl = el('p', { class: 'precision-fit__buy-price' });
      if (variant) priceEl.textContent = money(variant.price) + (variant.available ? '' : ' — currently unavailable');
      else if (pending) priceEl.textContent = 'Price shown once chosen';
      else priceEl.textContent = 'This combination is not offered — arranged through the consultation.';
      li.appendChild(priceEl);
      return { node: li, variant: variant && variant.available ? variant : null, pending: pending, consult: !pending && !variant };
    }
    function buySpec(b) {
      var r = b.result, enc = r.enc, lm = b.lm;
      var mat = b.assembled ? r.matChoice : pickMat(state, r);
      return { lm: lm, enc: enc, mat: mat, screen: b.screen || null, proj: r.proj || PROJ, key: b.assembled ? 'assembled' : lm.buildKey };
    }
    function renderBuy(b) {
      var spec = buySpec(b);
      var panel = el('div', { class: 'precision-fit__buy', 'data-buy-panel': spec.key });
      panel._spec = spec;
      fillBuy(panel);
      return panel;
    }
    function refreshBuy(panel) { panel.textContent = ''; fillBuy(panel); }
    function fillBuy(panel) {
      var spec = panel._spec, key = spec.key, lines = [], items = [], total = 0, pending = false, consult = false;
      var list = el('ul', { class: 'precision-fit__buy-list' });

      // enclosure — DIY or Pro kit by family; size is the room's, screen and framing are the buyer's.
      // Pro: the depth half of "Depth & Framing" is fixed by the choice, with/without pipes stays the buyer's.
      var isPro = encFamily(spec.enc) === 'pro';
      var encProd = CAT[isPro ? 'encl.carls.pro' : 'encl.carls.diy'] || null;
      var encFixed = { 'Enclosure Size': spec.enc.label };
      var depthWant = norm((spec.enc.depthFt || 5) + ' ft');
      var encChoose = isPro ? [{ name: 'Depth & Framing', keep: function (v) { var n = norm(v); return n === depthWant || n.indexOf(depthWant + ' ') === 0; } }] : ['Framing & Padding'];
      var screenOk = spec.screen && (!isPro || /premium|gray/i.test(spec.screen.name));
      if (screenOk) encFixed['Screen Material'] = spec.screen.name; else encChoose.unshift('Screen Material');
      lines.push(buyLine(isPro ? 'Pro enclosure and screen' : 'Enclosure and screen', encProd, encFixed, encChoose, key));

      // launch monitor and projector — single-variant products
      lines.push(buyLine('Launch monitor', CAT[spec.lm.id] || null, {}, [], key));
      lines.push(buyLine('Projector', CAT[spec.proj.id] || null, {}, [], key));

      // hitting mat — size is the room's, strip is the buyer's
      var matProd = CAT[MAT.id] || null;
      lines.push(buyLine('Hitting mat', matProd, { 'Mat Size': Math.round(spec.mat.wIn / 12) + ' × ' + Math.round(spec.mat.lIn / 12) }, ['Hitting Strip'], key));

      lines.forEach(function (ln) { list.appendChild(ln.node); if (ln.variant) { items.push({ id: ln.variant.id, quantity: 1 }); total += ln.variant.price; } if (ln.pending) pending = true; if (ln.consult) consult = true; });
      panel.appendChild(list);

      var foot = el('div', { class: 'precision-fit__buy-foot' });
      var anyJoined = lines.some(function (ln) { return ln.variant || ln.pending; });
      if (!anyJoined) {
        foot.appendChild(el('p', { class: 'precision-fit__buy-note', text: 'The components in this build are specified through the consultation today.' }));
      } else {
        var sum = el('p', { class: 'precision-fit__buy-total' });
        if (pending) sum.textContent = 'Choose the remaining options to see the total.';
        else sum.textContent = 'Total for the lines above: ' + money(total) + ' — before tax. Carl’s Place items ship free by ground to the lower 48 and D.C.; other manufacturers’ items carry a flat shipping charge at checkout.' + (consult ? ' Lines marked for the consultation are not included.' : '');
        foot.appendChild(sum);
        foot.appendChild(el('p', { class: 'precision-fit__buy-note', text: 'Items ship separately from their manufacturers; each shipment carries its own tracking. Carl’s Place recommends planning two weeks for made-to-order enclosure kits.' }));
        var btn = el('button', { type: 'button', class: 'precision-fit__choose precision-fit__choose--buy', text: 'Add these to the cart' });
        if (pending || !items.length) btn.disabled = true;
        btn.addEventListener('click', function () {
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = '/cart'; })
            .catch(function () { btn.disabled = false; btn.textContent = 'Add these to the cart'; foot.appendChild(el('p', { class: 'precision-fit__buy-note', role: 'alert', text: 'The cart did not accept that. Open each product from the links above to add it, or book the consultation.' })); });
        });
        foot.appendChild(el('div', { class: 'precision-fit__build-actions' }, [btn]));
      }
      panel.appendChild(foot);
    }

    // ---------- top-down plan ----------
    // ---------- the scene (Stage 3, 2026-10-08) ----------
    // ONE object, in inches: x across the room (0 at the left wall as the golfer faces the screen),
    // d from the screen wall toward the golfer, z up from the floor. The plan below and the photo
    // composite (assets/precision-room-photo.js) both draw from it; neither recomputes physics.
    function sceneFor(s, b) {
      var r = b.result; if (!r) return null;
      var enc = r.enc, m = r.m, lm = b.lm, P = r.proj || PROJ;
      var W = s.w, L = s.l, C = s.c, cx = W / 2;
      var rear = R.rearOfScreen.recIn;
      var mat = b.assembled ? (r.matChoice || pickMat(s, r)) : pickMat(s, r);
      var lefty = !!(s.golfers.length && s.golfers.every(function (g) { return g.hand === 'left'; }));
      var side = lefty ? -1 : 1;
      var tee = { x: cx, d: TEE };
      // The viewable opening sits centered in the frame — a drawing convention. Carl's publishes the
      // frame and the viewable area, not the offset between them (unknowns: enclosure.screenLowerEdgeIn).
      var bx = (enc.outerWIn - enc.viewableWIn) / 2, bz = (enc.outerHIn - enc.viewableHIn) / 2;
      var encl = { id: enc.id, family: encFamily(enc), label: enc.label, name: encName(enc),
        x0: cx - enc.outerWIn / 2, x1: cx + enc.outerWIn / 2, d0: rear, d1: rear + enc.floorDepthIn, dFrame: rear + enc.frameDepthIn, z0: 0, z1: enc.outerHIn };
      var screen = { x0: encl.x0 + bx, x1: encl.x1 - bx, z0: bz, z1: bz + enc.viewableHIn, d: rear, aspect: enc.viewableWIn / enc.viewableHIn };
      var matBox = { x0: tee.x - mat.lIn / 2, x1: tee.x + mat.lIn / 2, d0: tee.d - mat.wIn / 2, d1: tee.d + mat.wIn / 2, z0: 0, z1: MAT.thicknessIn, layout: mat.layout, wIn: mat.wIn, lIn: mat.lIn };
      var bi = lm.bodyIn || {}, lmBox, lmNote = null;
      if (lm.mountClass === 'overhead') {
        var dLm = tee.d - (lm.forwardOfTeeIn || 0);
        // Flush to the ceiling up to the top of the published bracket range; on a drop beyond it.
        // (The elevation draws the unit at the bottom of the range — its job is the worst-case clearance.)
        var top = Math.min(C, MAT.thicknessIn + lm.bracketAboveHittingSurfaceIn.max + bi.assembledIn);
        var pub = !!(bi.w && bi.d);
        lmBox = { x0: tee.x - (pub ? bi.w / 2 : 0), x1: tee.x + (pub ? bi.w / 2 : 0), d0: dLm - (pub ? bi.d / 2 : 0), d1: dLm + (pub ? bi.d / 2 : 0), z0: top - bi.assembledIn, z1: top, published: pub };
        if (!pub) lmNote = lm.vendor + ' does not publish the ' + lm.name + '’s footprint, so the unit is not drawn — its mounting point is.';
      } else if (lm.mountClass === 'rear') {
        var dR = tee.d + (lm.behindTeeMinIn || 96);
        lmBox = { x0: tee.x - bi.w / 2, x1: tee.x + bi.w / 2, d0: dR - bi.d / 2, d1: dR + bi.d / 2, z0: 0, z1: bi.h, published: !!(bi.w && bi.d) };
      } else {
        var sx0 = side > 0 ? tee.x - 14 - bi.w : tee.x + 14;
        lmBox = { x0: sx0, x1: sx0 + bi.w, d0: tee.d - 10, d1: tee.d - 10 + bi.d, z0: MAT.thicknessIn, z1: MAT.thicknessIn + bi.h, published: !!(bi.w && bi.d) };
      }
      var pb = P.bodyIn;
      var lensZ = m.proj.maxLens == null ? C - pb.h / 2 : Math.min(m.proj.maxLens, C - pb.h / 2);
      var proj = { id: P.id, name: P.name, x0: cx - pb.w / 2, x1: cx + pb.w / 2, d0: m.proj.t - pb.d / 2, d1: m.proj.t + pb.d / 2, z0: lensZ - pb.h / 2, z1: lensZ + pb.h / 2, lensRule: m.proj.lensRule };
      return {
        schemaVersion: '1.0', units: 'in',
        build: { key: b.assembled ? 'assembled' : lm.buildKey, name: b.assembled ? 'Your assembled build' : lm.buildName, source: b.assembled ? 'assembled' : 'curated' },
        room: { w: W, l: L, h: C },
        enclosure: encl, screen: screen, tee: tee,
        golfer: { side: side, lefty: lefty, x: tee.x + side * 11, heightIn: tallest(s) },
        mat: matBox,
        launchMonitor: { id: lm.id, name: lm.name, mountClass: lm.mountClass, box: lmBox, note: lmNote },
        projector: proj,
        obstructions: s.obs.map(function (o) { return { type: o.type, d0: o.d - 6, d1: o.d + 6, z0: o.clear, z1: C }; })
      };
    }
    function scenesForPhoto(s, ev) {
      var out = [];
      ev.builds.forEach(function (b) { if (b.result) out.push({ key: b.lm.buildKey, name: b.lm.buildName, scene: sceneFor(s, b) }); });
      var ab = assembledBuild(s);
      if (ab) out.push({ key: 'assembled', name: 'Your assembled build', scene: sceneFor(s, ab) });
      return out;
    }

    // ---------- "See it in your room" (Stage 3, D98/D99) ----------
    // The module is a separate asset, injected on the first tap so the page load is unchanged.
    var photoSrc = root.getAttribute('data-photo-src') || '';
    var photoReady = null;
    function loadPhotoModule() {
      if (window.PrecisionRoomPhoto) return Promise.resolve(window.PrecisionRoomPhoto);
      if (photoReady) return photoReady;
      photoReady = new Promise(function (resolve, reject) {
        var sc = document.createElement('script');
        sc.src = photoSrc; sc.async = true;
        sc.onload = function () { if (window.PrecisionRoomPhoto) resolve(window.PrecisionRoomPhoto); else { photoReady = null; reject(new Error('module')); } };
        sc.onerror = function () { photoReady = null; reject(new Error('load')); };
        document.head.appendChild(sc);
      });
      return photoReady;
    }
    function seeItButton(b) {
      var btn = el('button', { type: 'button', class: 'precision-fit__choose precision-fit__choose--photo', text: 'See it in your room' });
      btn.addEventListener('click', function () {
        var key = b.assembled ? 'assembled' : b.lm.buildKey;
        btn.disabled = true; btn.textContent = 'Opening…';
        var note = btn.parentNode.querySelector('.precision-fit__photo-note'); if (note) note.remove();
        loadPhotoModule().then(function (mod) {
          btn.disabled = false; btn.textContent = 'See it in your room';
          mod.open({ builds: scenesForPhoto(state, lastEval), initial: key, screenImage: D.screenPhotoImage || '', consultUrl: consultLink.href });
        }, function () {
          btn.disabled = false; btn.textContent = 'See it in your room';
          btn.parentNode.appendChild(el('p', { class: 'precision-fit__photo-note', role: 'alert', text: 'The room view did not load. Reload the page and try again, or bring the room to the consultation.' }));
        });
      });
      return btn;
    }

    // ---------- top-down plan (draws from the scene) ----------
    function renderPlan(s, b) {
      svgWrap.textContent = ''; legendEl.textContent = '';
      drawingBuildEl.textContent = b.assembled ? 'your assembled build' : b.lm.buildName;
      var r = b.result; if (!r) return;
      var sc = sceneFor(s, b);
      var enc = r.enc, m = r.m, lm = b.lm;
      var W = sc.room.w, L = sc.room.l;
      var PAD = 26, LEFT = 44, TOP = 30;
      var VW = W + LEFT + PAD, VH = L + TOP + PAD + 8;
      var svg = svgEl('svg', { viewBox: '0 0 ' + VW + ' ' + VH, role: 'img', 'aria-label': 'Top-down plan of the room with the ' + (b.assembled ? 'assembled build' : lm.buildName) + ' drawn to scale' });
      var ink = '#14181a', green = '#1f4b36';
      var X0 = LEFT, Y0 = TOP;                       // screen wall along the top edge
      var x = function (w) { return X0 + w; }, y = function (d) { return Y0 + d; };
      var cx = x(W / 2);
      var hair = { stroke: ink, 'stroke-width': '0.8', fill: 'none', 'vector-effect': 'non-scaling-stroke' };
      function line(x1, y1, x2, y2, extra) { svg.appendChild(svgEl('line', Object.assign({ x1: x1, y1: y1, x2: x2, y2: y2 }, hair, extra || {}))); }
      function rect(x1, y1, w, h, extra) { svg.appendChild(svgEl('rect', Object.assign({ x: x1, y: y1, width: w, height: h }, hair, extra || {}))); }
      function box(bx, extra) { rect(x(bx.x0), y(bx.d0), bx.x1 - bx.x0, bx.d1 - bx.d0, extra); }
      function text(tx, ty, str, extra) { var t = svgEl('text', Object.assign({ x: tx, y: ty, 'font-size': '6', fill: ink, 'font-family': 'inherit' }, extra || {})); t.textContent = str; svg.appendChild(t); }
      // clip to the room so the swing circle shows exactly where the walls cut it
      var defs = svgEl('defs', {}); var clip = svgEl('clipPath', { id: 'fit-room-clip' }); clip.appendChild(svgEl('rect', { x: x(0), y: y(0), width: W, height: L })); defs.appendChild(clip); svg.appendChild(defs);
      // room + screen wall
      rect(x(0), y(0), W, L); line(x(0), y(0), x(W), y(0), { 'stroke-width': '1.6' });
      // obstructions — depth known, lateral position not: full-width bands
      sc.obstructions.forEach(function (o) { rect(x(0), y(o.d0), W, o.d1 - o.d0, { fill: 'rgba(20,24,26,0.14)', stroke: 'none' }); });
      // enclosure footprint + screen face
      var E = sc.enclosure;
      box(E);
      line(x(E.x0), y(E.d0), x(E.x1), y(E.d0), { 'stroke-width': '2.2' });
      // hitting position
      var tee = { x: x(sc.tee.x), y: y(sc.tee.d) };
      var mat = sc.mat;
      box(mat, { fill: 'rgba(20,24,26,0.08)' });
      // swing area — the single green element, clipped by the walls
      var g = svgEl('g', { 'clip-path': 'url(#fit-room-clip)' });
      g.appendChild(svgEl('circle', { cx: tee.x, cy: tee.y, r: R.swingRadiusIn, stroke: green, 'stroke-width': '1.2', 'stroke-dasharray': '4 3', fill: 'rgba(31,75,54,0.06)', 'vector-effect': 'non-scaling-stroke' }));
      svg.appendChild(g);
      svg.appendChild(svgEl('circle', { cx: tee.x, cy: tee.y, r: '1.8', fill: ink }));
      // golfer side — a right-hander's ball is on their left, so they stand to the right of it (x+)
      var lefty = sc.golfer.lefty, side = sc.golfer.side;
      // launch monitor — at its published footprint where the maker publishes one; an overhead unit
      // without one keeps the symbolic 12 × 6 marker at its mounting point
      var LM = sc.launchMonitor.box;
      if (lm.mountClass === 'overhead') {
        if (LM.published) box(LM, { fill: ink, 'stroke-dasharray': '2 2' });
        else rect(tee.x - 6, y(LM.d0) - 3, 12, 6, { fill: ink, 'stroke-dasharray': '2 2' });
      } else box(LM, { fill: ink });
      // projector — ceiling-mounted, drawn dashed
      var PJ = sc.projector;
      box(PJ, { fill: 'rgba(20,24,26,0.35)', 'stroke-dasharray': '2 2' });
      // golfer from above — shoulders parallel to the target line, standing beside the ball on the
      // side the handedness puts them (a right-hander's ball is on their left)
      var gxp = x(sc.golfer.x);
      svg.appendChild(svgEl('ellipse', { cx: gxp, cy: tee.y, rx: '5', ry: '11', fill: 'rgba(20,24,26,0.10)', stroke: ink, 'stroke-width': '0.8', 'vector-effect': 'non-scaling-stroke' }));
      svg.appendChild(svgEl('circle', { cx: gxp, cy: tee.y, r: '3.2', fill: 'rgba(20,24,26,0.10)', stroke: ink, 'stroke-width': '0.8', 'vector-effect': 'non-scaling-stroke' }));
      // callouts — numbered to the legend below (same numbers as the elevation)
      callout(svg, x(E.x0) + 9, y(E.d0) + 9, 1);
      if (lm.mountClass === 'overhead') callout(svg, x(LM.x1) + 14, y((LM.d0 + LM.d1) / 2), 2);
      else if (lm.mountClass === 'rear') callout(svg, x(LM.x1) + 9, y((LM.d0 + LM.d1) / 2), 2);
      else callout(svg, side > 0 ? x(LM.x0) - 8 : x(LM.x1) + 8, y(LM.d0) + 2, 2);
      callout(svg, x(PJ.x1) + 9, y((PJ.d0 + PJ.d1) / 2), 3);
      callout(svg, x(mat.x0) - 9, y(mat.d1) - 6, 4);
      callout(svg, gxp + (lefty ? -14 : 14), tee.y + 12, 5);
      callout(svg, Math.min(x(W) - 8, tee.x + R.swingRadiusIn - 8), Math.min(y(L) - 8, tee.y + 10), 6, true);
      if (sc.obstructions.length) callout(svg, x(W) - 9, y((sc.obstructions[0].d0 + sc.obstructions[0].d1) / 2), 7);
      // dimensions
      line(x(0), Y0 - 14, x(W), Y0 - 14, { 'stroke-width': '0.6' }); line(x(0), Y0 - 18, x(0), Y0 - 10, { 'stroke-width': '0.6' }); line(x(W), Y0 - 18, x(W), Y0 - 10, { 'stroke-width': '0.6' });
      text(cx, Y0 - 19, ftin(W) + ' wide', { 'text-anchor': 'middle' });
      line(X0 - 16, y(0), X0 - 16, y(L), { 'stroke-width': '0.6' }); line(X0 - 20, y(0), X0 - 12, y(0), { 'stroke-width': '0.6' }); line(X0 - 20, y(L), X0 - 12, y(L), { 'stroke-width': '0.6' });
      text(X0 - 20, y(L / 2), ftin(L) + ' long', { 'text-anchor': 'middle', transform: 'rotate(-90 ' + (X0 - 20) + ' ' + y(L / 2) + ')' });
      line(x(W) + 8, y(0), x(W) + 8, tee.y, { 'stroke-width': '0.6', 'stroke-dasharray': '2 2' });
      text(x(W) + 12, y(TEE / 2), ftin(TEE) + ' to tee', { transform: 'rotate(90 ' + (x(W) + 12) + ' ' + y(TEE / 2) + ')', 'text-anchor': 'middle' });
      svgWrap.appendChild(svg);

      var items = [
        ['Enclosure footprint and screen — ' + encName(enc).replace('Carl’s Place ', 'Carl’s ') + ', ' + ftin(enc.outerWIn) + ' wide, ' + encDepthText(enc) + ', 1 ft off the screen wall at the top. The heavy line is the screen face.', ''],
        [lm.mountClass === 'overhead' ? 'Launch monitor — ' + lm.name + ', overhead, ' + fwdText(lm) + (LM.published ? ', drawn at ' + lm.vendor + '’s published ' + inchesOnly(LM.x1 - LM.x0) + ' × ' + inchesOnly(LM.d1 - LM.d0) + '.' : '.') : lm.mountClass === 'rear' ? 'Launch monitor — ' + lm.name + ', radar ' + ftin(lm.behindTeeMinIn || 96) + ' behind the tee.' : 'Launch monitor — ' + lm.name + ', beside the ball on the hitting surface.', ''],
        ['Projector — ' + sc.projector.name + ', overhead, ' + ftin(m.proj.t) + ' from the screen.', ''],
        ['Hitting mat — ' + ftin(mat.lIn) + ' across, ' + ftin(mat.wIn) + ' deep, ' + mat.layout + ' hitting area.' + (m.width.offset ? ' The offset position is set at installation; the plan shows the center.' : ''), ''],
        ['Golfer at the tee, from above — standing on the ' + (lefty ? 'left' : 'right') + ' of the ball, shoulders along the target line.', ''],
        ['Swing area — 7 ft around the golfer, from Carl’s Place. Where the walls cut the circle, the room sits at Carl’s published minimum rather than the recommendation.', 'is-green']
      ];
      if (sc.obstructions.length) items.push(['Obstructions at their distance from the screen wall — drawn full-width because the tool asks for depth only.', '']);
      items.forEach(function (it) { legendEl.appendChild(el('li', { class: it[1], text: it[0] })); });
    }

    function renderDrawingFor(s, b) {
      root.querySelector('[data-drawing-kind]').textContent = s.view === 'plan' ? 'Top-down plan' : 'Side elevation';
      Array.prototype.forEach.call(root.querySelectorAll('[data-view]'), function (btn) { btn.setAttribute('aria-pressed', String(btn.getAttribute('data-view') === s.view)); });
      if (s.view === 'plan') renderPlan(s, b); else renderDrawing(s, b);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-view]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!state || !lastEval) return;
        state.view = btn.getAttribute('data-view');
        var sel = selectedBuild(state, lastEval); if (sel) renderDrawingFor(state, sel);
        var url = new URL(window.location.href); url.searchParams.set('r', encodeState(state)); try { history.replaceState(null, '', url.toString()); } catch (e) {}
      });
    });
    function selectedBuild(s, ev) {
      if (s.selected === 'assembled') return assembledBuild(s);
      return ev.builds.filter(function (b) { return b.lm.buildKey === s.selected && b.result; })[0] || null;
    }

    function renderProvenance(ev) {
      provEl.textContent = '';
      var used = {};
      var keys = ['carls-measure', 'carls-encl-pdf', 'carls-xo2', 'carls-eye-mini-diag', 'uneekor-xo2', 'uneekor-eye-mini', 'uneekor-warranty', 'benq-lk936st', 'benq-throw', 'carls-hotshot'];
      if (state && state.assembled) {
        var alm = lmByKey(state.assembled.lm), apj = projById(state.assembled.proj);
        if (alm) keys = keys.concat(alm.srcs || []);
        if (apj) keys = keys.concat(apj.srcs || []);
      }
      keys.forEach(function (k) {
        var src = D.sources[k]; if (!src || used[src.url]) return; used[src.url] = true;
        provEl.appendChild(el('li', { text: src.name }));
      });
      provEl.appendChild(el('li', { text: 'Where no manufacturer publishes a figure — how much ceiling your swing needs, the drop of the projector mount — the tool says so rather than estimating.' }));
    }

    function render(s, ev) {
      var vc = verdictCopy(ev, s);
      root.querySelector('[data-verdict-eyebrow]').textContent = vc.eyebrow;
      root.querySelector('[data-verdict-title]').textContent = vc.title;
      root.querySelector('[data-verdict-sub]').textContent = vc.sub;

      // pick a selected build: keep the user's (curated or assembled), else the first that has a result
      var keep = s.selected === 'assembled' ? !!assembledBuild(s) : ev.builds.some(function (b) { return b.lm.buildKey === s.selected && b.result; });
      if (!keep) {
        var firstOk = ev.builds.filter(function (b) { return b.result; })[0];
        s.selected = firstOk ? firstOk.lm.buildKey : null;
      }
      buildsEl.textContent = '';
      ev.builds.forEach(function (b) {
        var card = renderBuild(s, b, ev);
        if (s.selected === b.lm.buildKey) card.classList.add('precision-fit__build--selected');
        buildsEl.appendChild(card);
      });
      renderSwing(s, ev);
      renderAssemble(s, ev);
      var sel = selectedBuild(s, ev);
      var drawing = root.querySelector('[data-drawing]');
      if (sel && sel.result) { drawing.hidden = false; renderDrawingFor(s, sel); } else { drawing.hidden = true; }
      renderProvenance(ev);

      // handoff
      var env = sel ? envelopeFor(s, sel) : null;
      var enc = encodeState(s);
      try {
        sessionStorage.setItem('pig:room', JSON.stringify({ width: s.w / 12, length: s.l / 12, ceiling: s.c / 12, widthIn: s.w, lengthIn: s.l, ceilingIn: s.c, golfers: s.golfers, obstructions: s.obs }));
        if (env) sessionStorage.setItem('pig:envelope', JSON.stringify(env));
      } catch (e) {}
      consultLink.href = consultBase + (consultBase.indexOf('?') > -1 ? '&' : '?') + 'r=' + enc;
      var url = new URL(window.location.href); url.searchParams.set('r', enc); url.hash = 'room-fit';
      try { history.replaceState(null, '', url.toString()); } catch (e) {}
      resultsEl.hidden = false;
    }

    // ---------- URL state ----------
    function encodeState(s) {
      var a = s.assembled ? [s.assembled.lm, s.assembled.enc, s.assembled.screen, s.assembled.mat, s.assembled.proj || null] : null;
      var compact = [s.w, s.l, s.c, s.golfers.map(function (g) { return [g.h, g.hand === 'left' ? 'l' : 'r']; }), s.obs.map(function (o) { return [o.type, o.d, o.clear]; }), s.swingTest === true ? 1 : s.swingTest === false ? 0 : null, s.selected || null, a, s.view === 'plan' ? 'p' : 'e'];
      var json = JSON.stringify(compact);
      return btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }
    function decodeState(str) {
      try {
        var b64 = str.replace(/-/g, '+').replace(/_/g, '/'); while (b64.length % 4) b64 += '=';
        var a = JSON.parse(decodeURIComponent(escape(atob(b64))));
        return { w: +a[0], l: +a[1], c: +a[2], golfers: (a[3] || []).map(function (g) { return { h: +g[0], hand: g[1] === 'l' ? 'left' : 'right' }; }), obs: (a[4] || []).map(function (o) { return { type: o[0], d: +o[1], clear: +o[2] }; }), swingTest: a[5] === 1 ? true : a[5] === 0 ? false : null, selected: a[6] || null,
                 assembled: a[7] ? { lm: a[7][0], enc: a[7][1], screen: a[7][2], mat: a[7][3], proj: a[7][4] || null } : null, view: a[8] === 'p' ? 'plan' : 'elevation' };
      } catch (e) { return null; }
    }
    function fillForm(s) {
      var f = form.elements;
      f.w_ft.value = Math.floor(s.w / 12); f.w_in.value = Math.round((s.w % 12) * 4) / 4;
      f.l_ft.value = Math.floor(s.l / 12); f.l_in.value = Math.round((s.l % 12) * 4) / 4;
      f.c_ft.value = Math.floor(s.c / 12); f.c_in.value = Math.round((s.c % 12) * 4) / 4;
      golfersEl.textContent = ''; obstructionsEl.textContent = '';
      s.golfers.forEach(function (g) { addGolfer(g.h, g.hand); });
      if (!s.golfers.length) addGolfer();
      s.obs.forEach(function (o) { addObstruction(o.type, o.d, o.clear); });
    }

    // ---------- run ----------
    function run(focus) {
      var s = readState();
      var err = validate(s);
      if (err) { errorEl.textContent = err; errorEl.hidden = false; return; }
      errorEl.hidden = true;
      state = s;
      lastEval = evaluate(s);
      render(s, lastEval);
      if (focus) {
        var t = root.querySelector('[data-verdict-title]');
        resultsEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        setTimeout(function () { t.focus({ preventScroll: true }); }, reduceMotion ? 0 : 400);
      }
    }
    // A result opens as its own page view (?r=…&fit=1), so the store's own Meta and Google apps count it the way they
    // count the booking page (D79). Nothing tracking-related runs in the theme (Ads v3, Q56).
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var s = readState(), err = validate(s);
      if (err) { errorEl.textContent = err; errorEl.hidden = false; return; }
      // the same room again (the page already shows it) re-runs in place: a page view only when the room changes
      var cur = new URLSearchParams(window.location.search).get('r'), prev = cur ? decodeState(cur) : null;
      function roomKey(x) { return JSON.stringify([x.w, x.l, x.c, x.golfers, x.obs]); }
      if (prev && roomKey(prev) === roomKey(s)) { run(true); return; }
      var to = new URL(window.location.href);
      to.search = ''; to.searchParams.set('r', encodeState(s)); to.searchParams.set('fit', '1'); to.hash = '';
      window.location.assign(to.toString());
    });

    copyBtn.addEventListener('click', function () {
      var url = window.location.href;
      function done(ok) { copiedEl.textContent = ok ? 'Link copied.' : url; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
      else done(false);
    });

    // initial rows / restore
    var params = new URLSearchParams(window.location.search);
    var restored = params.get('r') ? decodeState(params.get('r')) : null;
    var fitView = params.get('fit') === '1';
    if (restored && restored.w) { fillForm(restored); state = restored; run(false); if (fitView) showResultNow(); }
    else { addGolfer(); }
    // a result page opens on the result: jump there now, and once more when late images have loaded, unless the
    // visitor has already scrolled or typed
    function showResultNow() {
      var t = root.querySelector('[data-verdict-title]'), moved = false;
      function go() { resultsEl.scrollIntoView({ block: 'start' }); try { t.focus({ preventScroll: true }); } catch (e) {} }
      go();
      ['wheel', 'touchstart', 'keydown'].forEach(function (n) { window.addEventListener(n, function () { moved = true; }, { once: true, passive: true }); });
      if (document.readyState !== 'complete') window.addEventListener('load', function () { if (!moved) go(); });
    }
    // drop ?fit=1 once the page view has been reported, so a reload or a copied link is not a second result
    function settleFit() {
      try { var u = new URL(window.location.href); if (u.searchParams.has('fit')) { u.searchParams.delete('fit'); history.replaceState(null, '', u.toString()); } } catch (e) {}
    }
    if (fitView) {
      if (document.readyState === 'complete') setTimeout(settleFit, 4000);
      else window.addEventListener('load', function () { setTimeout(settleFit, 4000); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
